/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CheckPointTypeV1: { input: string; output: string; }
  Cursor: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Duration: { input: string; output: string; }
  JSON: { input: unknown; output: unknown; }
  Upload: { input: unknown; output: unknown; }
};

export type AiConversationFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  hasAiConversationSessionWith?: InputMaybe<AiConversationSessionFilter>;
  hasAudioAWSWith?: InputMaybe<AudioAwsFilter>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  role?: InputMaybe<Array<AiConversationRole>>;
  source?: InputMaybe<Array<Device>>;
  updatedAt?: InputMaybe<DateTimeRange>;
};

export type AiConversationOrder = {
  key?: InputMaybe<AiConversationOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AiConversationOrderKey {
  CreatedAt = 'CREATED_AT',
  HighestDuration = 'HIGHEST_DURATION'
}

export enum AiConversationRole {
  System = 'SYSTEM',
  User = 'USER'
}

export type AiConversationSessionFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  hasAiConversationsWith?: InputMaybe<AiConversationFilter>;
  hasBingoStudyLevel?: InputMaybe<Scalars['Boolean']['input']>;
  hasBingoSubjectWith?: InputMaybe<BingoSubjectFilter>;
  hasBookLesson?: InputMaybe<Scalars['Boolean']['input']>;
  hasDuolingoLevel?: InputMaybe<Scalars['Boolean']['input']>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Array<Device>>;
  type?: InputMaybe<Array<AiConversationSessionType>>;
};

export type AiConversationSessionOrder = {
  key?: InputMaybe<AiConversationSessionOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AiConversationSessionOrderKey {
  HighestDuration = 'HIGHEST_DURATION'
}

export enum AiConversationSessionType {
  Call = 'CALL',
  Chat = 'CHAT',
  Mix = 'MIX',
  Topic = 'TOPIC'
}

export type AiConversationSummaryFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  learnerProfileID?: InputMaybe<Array<Scalars['ID']['input']>>;
  source?: InputMaybe<Array<AiConversationSummarySource>>;
  userStatus?: InputMaybe<AiConversationSummaryUserStatus>;
};

export type AiConversationSummaryOrder = {
  key?: InputMaybe<AiConversationSummaryOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AiConversationSummaryOrderKey {
  HighestDuration = 'HIGHEST_DURATION'
}

export enum AiConversationSummarySource {
  MobileExam = 'MOBILE_EXAM',
  WebExam = 'WEB_EXAM'
}

export enum AiConversationSummaryUserStatus {
  Subscribed = 'SUBSCRIBED',
  UnSubscribed = 'UN_SUBSCRIBED'
}

export enum AiConversationType {
  Call = 'CALL',
  Chat = 'CHAT'
}

export enum AiPartnerConversationAttachmentType {
  File = 'FILE',
  Image = 'IMAGE'
}

export type AiPartnerConversationFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  hasAiPartnerThreadWith?: InputMaybe<AiPartnerThreadFilter>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  role?: InputMaybe<Array<AiPartnerConversationRole>>;
  source?: InputMaybe<Array<Device>>;
  updatedAt?: InputMaybe<DateTimeRange>;
};

export enum AiPartnerConversationRole {
  System = 'SYSTEM',
  User = 'USER'
}

export type AiPartnerThreadFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  source?: InputMaybe<Array<Device>>;
  updatedAt?: InputMaybe<DateTimeRange>;
};

export type AiSpeakingRecordFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<InputMaybe<AiSpeakingRecordType>>>;
};

export enum AiSpeakingRecordType {
  General = 'GENERAL',
  Ielts = 'IELTS',
  Ket = 'KET',
  Pet = 'PET'
}

export type AiWritingRecordFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  task?: InputMaybe<Array<AiWritingRecordTask>>;
};

export enum AiWritingRecordTask {
  Flyers = 'FLYERS',
  General = 'GENERAL',
  IeltsTask_1 = 'IELTS_TASK_1',
  IeltsTask_2 = 'IELTS_TASK_2',
  KetPart_6 = 'KET_PART_6',
  KetPart_7 = 'KET_PART_7',
  Pet = 'PET'
}

export enum AchievementName {
  ErrorMechanic = 'ERROR_MECHANIC',
  Explorer = 'EXPLORER',
  LongestChain = 'LONGEST_CHAIN',
  OlympicAthlete = 'OLYMPIC_ATHLETE',
  PerfectLessons = 'PERFECT_LESSONS',
  StarsHunterWarlord = 'STARS_HUNTER_WARLORD',
  TournamentStar = 'TOURNAMENT_STAR',
  Week = 'WEEK',
  YearOfTheDragon = 'YEAR_OF_THE_DRAGON'
}

export type ActivationCodeFilter = {
  hasDiscountWith?: InputMaybe<DiscountFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum ActivationCodeType {
  Agent = 'agent',
  Giveaway = 'giveaway',
  GiveawayAgent = 'giveaway_agent',
  Iservice = 'iservice',
  MaxTrial = 'max_trial',
  Partner = 'partner',
  Reissue = 'reissue',
  Retail = 'retail',
  RetailManual = 'retail_manual',
  TeacherCode = 'teacher_code',
  Test = 'test',
  Vnpay = 'vnpay'
}

export type ActivationCodeUserFilter = {
  hasActiveCodeWith?: InputMaybe<ActivationCodeFilter>;
};

export enum ActivityStatusChallenge {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Running = 'RUNNING'
}

export type AdditionalInfoInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AdminActivationCodeUpdateInput = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<ActivationCodeType>;
};

export type AdminActiveCodeInput = {
  code: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type AdminBingoStudyBatchCheckPointInput = {
  checkPoint: AdminCheckPointCreateInput;
  parts: Array<AdminBingoStudyPartCreateInput>;
};

export type AdminBingoStudyBatchCreateInput = {
  units: Array<AdminBingoStudyBatchUnitInput>;
};

export type AdminBingoStudyBatchLevelInput = {
  checkPoints: Array<AdminBingoStudyBatchCheckPointInput>;
  level: AdminBingoStudyLevelCreateInput;
};

export enum AdminBingoStudyBatchStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type AdminBingoStudyBatchUnitInput = {
  levels: Array<AdminBingoStudyBatchLevelInput>;
  /** Required when unitId is not set — creates a new unit. */
  unit?: InputMaybe<AdminBingoStudyUnitCreateInput>;
  /** If provided, use existing unit instead of creating a new one. */
  unitId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminBingoStudyLevelCreateInput = {
  bingoSubjectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkPointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  type: BingoStudyLevelType;
};

export type AdminBingoStudyLevelUpdateInput = {
  bingoSubjectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkPointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<BingoStudyLevelType>;
};

export type AdminBingoStudyPartCreateInput = {
  alternativePartId?: InputMaybe<Scalars['ID']['input']>;
  challenge?: InputMaybe<BingoStudyChallengeInput>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  name: Scalars['String']['input'];
  story?: InputMaybe<BingoStudyStoryInput>;
  title: Scalars['String']['input'];
  type: BingoStudyPartType;
};

export type AdminBingoStudyPartUpdateInput = {
  alternativePartId?: InputMaybe<Scalars['ID']['input']>;
  challenge?: InputMaybe<BingoStudyChallengeInput>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  story?: InputMaybe<BingoStudyStoryInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BingoStudyPartType>;
};

export type AdminBingoStudyPathCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
  studyTimeEst?: InputMaybe<Scalars['Duration']['input']>;
};

export type AdminBingoStudyPathUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  studyTimeEst?: InputMaybe<Scalars['Duration']['input']>;
};

export type AdminBingoStudyUnitCreateInput = {
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminBingoStudyUnitUpdateInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminBookCreateInput = {
  coverImageId: Scalars['String']['input'];
  levels: Array<CefrLevel>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<BookStatus>;
};

export type AdminBookLessonCreateInput = {
  contentHtml: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  unitId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminBookLessonUpdateInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  unitId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminBookUnitCreateInput = {
  bookId?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  lessonType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  topic: Scalars['String']['input'];
};

export type AdminBookUnitUpdateInput = {
  bookId?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lessonType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type AdminBookUpdateInput = {
  coverImageId?: InputMaybe<Scalars['String']['input']>;
  customDomains?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludedCustomDomains?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  levels?: InputMaybe<Array<CefrLevel>>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<BookStatus>;
};

export type AdminCheckPointBingoStudyPartInput = {
  partId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type AdminCheckPointCreateInput = {
  addCustomDomainIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTopicIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  adminRank?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed?: InputMaybe<Scalars['Int']['input']>;
  coin?: InputMaybe<Scalars['Int']['input']>;
  cpType?: InputMaybe<CheckPointType>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  diamond?: InputMaybe<Scalars['Int']['input']>;
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  interactiveVideo?: InputMaybe<CheckPointInteractiveVideoInput>;
  isBoss?: InputMaybe<Scalars['Boolean']['input']>;
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  levels: Array<CefrLevel>;
  listeningTime?: InputMaybe<Scalars['Duration']['input']>;
  maxGrade?: InputMaybe<Scalars['Float']['input']>;
  maxScore?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  placementTestGroupId?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  readingTime?: InputMaybe<Scalars['Duration']['input']>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  source?: InputMaybe<Scalars['String']['input']>;
  speakingTime?: InputMaybe<Scalars['Duration']['input']>;
  star?: InputMaybe<Scalars['Int']['input']>;
  teacherDiamond?: InputMaybe<Scalars['Int']['input']>;
  testCount?: InputMaybe<Scalars['Int']['input']>;
  testLevelId?: InputMaybe<Scalars['ID']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
  type: Scalars['CheckPointTypeV1']['input'];
  writingTime?: InputMaybe<Scalars['Duration']['input']>;
};

export type AdminCheckPointCustomDomainUpdateInput = {
  checkPointId: Scalars['ID']['input'];
  customDomainIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AdminCheckPointDuolingoPartInput = {
  partId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type AdminCheckPointExamPartUpdateInput = {
  examPartID: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
  videoTimestamp?: InputMaybe<Scalars['Float']['input']>;
};

export type AdminCheckPointTopicRemoveInput = {
  checkPointId: Scalars['ID']['input'];
  topicId: Array<Scalars['ID']['input']>;
};

export type AdminCheckPointTopicUpdateInput = {
  checkPointId: Scalars['ID']['input'];
  topicId: Array<Scalars['ID']['input']>;
};

export type AdminCheckPointUpdateInput = {
  addCustomDomainIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTopicIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  adminRank?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed?: InputMaybe<Scalars['Int']['input']>;
  coin?: InputMaybe<Scalars['Int']['input']>;
  cpType?: InputMaybe<CheckPointType>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  diamond?: InputMaybe<Scalars['Int']['input']>;
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  interactiveVideo?: InputMaybe<CheckPointInteractiveVideoInput>;
  isBoss?: InputMaybe<Scalars['Boolean']['input']>;
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  listeningTime?: InputMaybe<Scalars['Duration']['input']>;
  maxGrade?: InputMaybe<Scalars['Float']['input']>;
  maxScore?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  placementTestGroupId?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  readingTime?: InputMaybe<Scalars['Duration']['input']>;
  removeCustomDomainIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTopicIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  source?: InputMaybe<Scalars['String']['input']>;
  speakingTime?: InputMaybe<Scalars['Duration']['input']>;
  star?: InputMaybe<Scalars['Int']['input']>;
  teacherDiamond?: InputMaybe<Scalars['Int']['input']>;
  testCount?: InputMaybe<Scalars['Int']['input']>;
  testLevelId?: InputMaybe<Scalars['ID']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
  type?: InputMaybe<Scalars['CheckPointTypeV1']['input']>;
  writingTime?: InputMaybe<Scalars['Duration']['input']>;
};

export type AdminClassStudentBulkJoinInput = {
  inputs: Array<AdminClassStudentBulkJoinInputItem>;
};

export type AdminClassStudentBulkJoinInputItem = {
  classCode: Scalars['String']['input'];
  /** Email (optional if phone provided) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Phone number (optional if email provided) */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Username (optional) */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AdminCloneCheckPointInput = {
  checkPointId: Scalars['ID']['input'];
};

export type AdminCreateDiscountInput = {
  amount: Scalars['Float']['input'];
  campaignMinimumAmount?: InputMaybe<Scalars['Float']['input']>;
  campaignMinimumItem?: InputMaybe<Scalars['Int']['input']>;
  code: Scalars['String']['input'];
  discountType: DiscountDiscountType;
  endDate: Scalars['DateTime']['input'];
  eventType?: InputMaybe<DiscountEventType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxDiscount?: InputMaybe<Scalars['Float']['input']>;
  oneTime?: InputMaybe<Scalars['Boolean']['input']>;
  sourceType?: InputMaybe<DiscountSourceType>;
  startDate: Scalars['DateTime']['input'];
  status?: InputMaybe<DiscountStatus>;
};

export type AdminCreateFirmwareReleaseInput = {
  checksumSha256?: InputMaybe<Scalars['String']['input']>;
  /** Board type this build targets, e.g. "xingzhi-cube-1.54tft-wifi". Empty/omitted applies to any board. */
  deviceType?: InputMaybe<Scalars['String']['input']>;
  /** Install even if the device reports an equal/newer version. For emergency re-flash only. */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** S3 key of the already-uploaded .bin, e.g. firmware/xingzhi-cube-1.54tft-wifi/2.3.0/xiaozhi.bin */
  s3Key: Scalars['String']['input'];
  sizeBytes?: InputMaybe<Scalars['Int']['input']>;
  version: Scalars['String']['input'];
};

export type AdminCreateOrderCodeInput = {
  activeFreeIeltsDiamond?: InputMaybe<Scalars['Boolean']['input']>;
  aiSpeakingCount?: InputMaybe<Scalars['Int']['input']>;
  aiWritingCount?: InputMaybe<Scalars['Int']['input']>;
  codeType?: InputMaybe<OrderCodeCodeType>;
  description: Scalars['String']['input'];
  diamond?: InputMaybe<Scalars['Int']['input']>;
  packageId?: InputMaybe<Scalars['ID']['input']>;
  planDay?: InputMaybe<Scalars['Duration']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  toTeacherProfileId?: InputMaybe<Scalars['ID']['input']>;
  type: OrderCodeType;
};

export type AdminCreateTtsVoiceInput = {
  category: TtsVoiceCategory;
  displayName: Scalars['String']['input'];
  /** Required: ent's TtsVoice.gender has no default. Synced to Inworld for voices this workspace owns. */
  gender: TtsVoiceGender;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<TtsVoiceSource>;
  voiceId: Scalars['String']['input'];
};

export type AdminCreateVersionNotificationInput = {
  appType: AppTypeMobile;
  contentHTML: Scalars['String']['input'];
  contentHTMLEn: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  showDomain?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['DateTime']['input'];
  status: Status;
  style?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['String']['input'];
  videoId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminCustomDomainUpdateInput = {
  canRefund?: InputMaybe<Scalars['Boolean']['input']>;
  createStudentFree?: InputMaybe<Scalars['Boolean']['input']>;
  disabledStudentChangeName?: InputMaybe<Scalars['Boolean']['input']>;
  disabledStudentLeaveClass?: InputMaybe<Scalars['Boolean']['input']>;
  disabledUpdatePhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  domainName?: InputMaybe<Scalars['String']['input']>;
  enabledStudentManagement?: InputMaybe<Scalars['Boolean']['input']>;
  fullDomainName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  meta?: InputMaybe<DomainDataInput>;
  onlineClass?: InputMaybe<Scalars['Boolean']['input']>;
  showDiamond?: InputMaybe<Scalars['Boolean']['input']>;
  showWallet?: InputMaybe<Scalars['Boolean']['input']>;
  teacherID?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminDuolingoBatchCheckPointInput = {
  checkPoint: AdminCheckPointCreateInput;
  parts: Array<AdminDuolingoPartCreateInput>;
};

export type AdminDuolingoBatchCreateInput = {
  units: Array<AdminDuolingoBatchUnitInput>;
};

export type AdminDuolingoBatchLevelInput = {
  checkPoints: Array<AdminDuolingoBatchCheckPointInput>;
  level: AdminDuolingoLevelCreateInput;
};

export enum AdminDuolingoBatchStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type AdminDuolingoBatchUnitInput = {
  levels: Array<AdminDuolingoBatchLevelInput>;
  /** Required when unitId is not set — creates a new unit. */
  unit?: InputMaybe<AdminDuolingoUnitCreateInput>;
  /** If provided, use existing unit instead of creating a new one. */
  unitId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminDuolingoLevelCreateInput = {
  bingoSubjectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkPointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  type: DuolingoLevelType;
};

export type AdminDuolingoLevelUpdateInput = {
  bingoSubjectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkPointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<DuolingoLevelType>;
};

export type AdminDuolingoPartCreateInput = {
  alternativePartId?: InputMaybe<Scalars['ID']['input']>;
  challenge?: InputMaybe<DuolingoChallengeInput>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  name: Scalars['String']['input'];
  story?: InputMaybe<DuolingoStoryInput>;
  title: Scalars['String']['input'];
  type: DuolingoPartType;
};

export type AdminDuolingoPartUpdateInput = {
  alternativePartId?: InputMaybe<Scalars['ID']['input']>;
  challenge?: InputMaybe<DuolingoChallengeInput>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  story?: InputMaybe<DuolingoStoryInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DuolingoPartType>;
};

export type AdminDuolingoPathCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
  studyTimeEst?: InputMaybe<Scalars['Duration']['input']>;
};

export type AdminDuolingoPathUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  studyTimeEst?: InputMaybe<Scalars['Duration']['input']>;
};

export type AdminDuolingoUnitCreateInput = {
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminDuolingoUnitUpdateInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminExamPartCreateInput = {
  addContents?: InputMaybe<Array<ExamPartContentCreateInput>>;
  addQuestions?: InputMaybe<Array<ExamQuestionCreateInput>>;
  answerExplanationHTML?: InputMaybe<Scalars['String']['input']>;
  answerExplanationHTMLEn?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<ExamPartBodyInput>;
  maxScore: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  partType: ExamPartType;
  structureType: ExamStructureType;
  time?: InputMaybe<Scalars['Duration']['input']>;
  title: Scalars['String']['input'];
};

export type AdminExamPartUpdateInput = {
  addContents?: InputMaybe<Array<ExamPartContentCreateInput>>;
  addQuestions?: InputMaybe<Array<ExamQuestionCreateInput>>;
  answerExplanationHTML?: InputMaybe<Scalars['String']['input']>;
  answerExplanationHTMLEn?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<ExamPartBodyInput>;
  deleteContents?: InputMaybe<Array<Scalars['ID']['input']>>;
  deleteQuestions?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  maxScore?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partType?: InputMaybe<ExamPartType>;
  structureType?: InputMaybe<ExamStructureType>;
  time?: InputMaybe<Scalars['Duration']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateContents?: InputMaybe<Array<ExamPartContentUpdateInput>>;
  updateQuestions?: InputMaybe<Array<ExamQuestionUpdateInput>>;
};

export type AdminImpersonateUserInput = {
  userId: Scalars['ID']['input'];
};

export type AdminNotificationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  hasPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<NotificationMetaInput>;
  profileID?: InputMaybe<Scalars['ID']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<NotificationSource>;
  teacherID?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  typeNotification?: InputMaybe<NotificationTypeNotification>;
};

export type AdminPartTopicUpdateInput = {
  partExamReadingId?: InputMaybe<Scalars['ID']['input']>;
  partExamSpeakingId?: InputMaybe<Scalars['ID']['input']>;
  partExamWritingId?: InputMaybe<Scalars['ID']['input']>;
  partIeltsSpeakingId?: InputMaybe<Scalars['ID']['input']>;
  topicId: Array<Scalars['ID']['input']>;
};

export type AdminPartnerAccessTokenCreateInput = {
  teacherProfileId: Scalars['ID']['input'];
};

export type AdminPartnerSchoolInviteTeachersAcceptAllInput = {
  schoolIds: Array<Scalars['ID']['input']>;
};

export type AdminPlacementTestGroupCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminPlacementTestGroupUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminSetDeviceOtaEnabledInput = {
  /** Global ID of the device. Supply exactly one of deviceId or mac. */
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  /** Device eFuse MAC, case-insensitive. Supply exactly one of deviceId or mac. */
  mac?: InputMaybe<Scalars['String']['input']>;
  /** True lets this device take published firmware updates; false holds it on its current build. */
  otaEnabled: Scalars['Boolean']['input'];
};

export type AdminSpeakingPartCreateInput = {
  addQuestions?: InputMaybe<Array<SpeakingQuestionCreateInput>>;
  body?: InputMaybe<SpeakingPartBodyInput>;
  name: Scalars['String']['input'];
  partType: SpeakingPartType;
  time?: InputMaybe<Scalars['Duration']['input']>;
  title: Scalars['String']['input'];
};

export type AdminSpeakingPartUpdateInput = {
  addQuestions?: InputMaybe<Array<SpeakingQuestionCreateInput>>;
  body?: InputMaybe<SpeakingPartBodyInput>;
  deleteQuestions?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  partType?: InputMaybe<SpeakingPartType>;
  time?: InputMaybe<Scalars['Duration']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateQuestions?: InputMaybe<Array<SpeakingQuestionUpdateInput>>;
};

export type AdminStudyCharacterCreateInput = {
  imageId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AdminStudyCharacterUpdateInput = {
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AdminTestLevelCreateInput = {
  addExamSettings?: InputMaybe<Array<AdminTestLevelExamSettingCreateInput>>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  metadata?: InputMaybe<TestLevelMetaInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  typeTestLevel: TypeExamTestLevel;
};

export type AdminTestLevelExamSettingCreateInput = {
  executionTime: Scalars['Duration']['input'];
  structureType: ExamStructureType;
};

export type AdminTestLevelExamSettingUpdateInput = {
  executionTime: Scalars['Duration']['input'];
  structureType: ExamStructureType;
};

export type AdminTestLevelUpdateInput = {
  addExamSettings?: InputMaybe<Array<AdminTestLevelExamSettingCreateInput>>;
  color?: InputMaybe<Scalars['String']['input']>;
  deleteExamSettings: Array<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  levels?: InputMaybe<Array<CefrLevel>>;
  metadata?: InputMaybe<TestLevelMetaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  typeTestLevel?: InputMaybe<TypeExamTestLevel>;
  updateExamSettings?: InputMaybe<Array<AdminTestLevelExamSettingUpdateInput>>;
};

export type AdminTopicCreateInput = {
  appTypes?: InputMaybe<Array<AppType>>;
  name: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
};

export type AdminTopicUpdateInput = {
  appTypes?: InputMaybe<Array<AppType>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateDiscountInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  campaignMinimumAmount?: InputMaybe<Scalars['Float']['input']>;
  campaignMinimumItem?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<DiscountDiscountType>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventType?: InputMaybe<DiscountEventType>;
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxDiscount?: InputMaybe<Scalars['Float']['input']>;
  oneTime?: InputMaybe<Scalars['Boolean']['input']>;
  sourceType?: InputMaybe<DiscountSourceType>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DiscountStatus>;
};

export type AdminUpdateFirmwareReleaseInput = {
  /** Install even if the device reports an equal/newer version. For emergency re-flash only. */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminUpdateOrderCodeInput = {
  id: Scalars['ID']['input'];
  status: OrderCodeStatus;
};

export type AdminUpdateTestLevelPackageFlyerInput = {
  packageID: Scalars['ID']['input'];
  testLevelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AdminUpdateTtsVoiceInput = {
  category?: InputMaybe<TtsVoiceCategory>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<TtsVoiceGender>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<TtsVoiceSource>;
  voiceId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateUsernameDataInput = {
  id: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};

export type AdminUpdateUsernameInput = {
  listUser: Array<AdminUpdateUsernameDataInput>;
};

export type AdminUpdateVersionNotificationInput = {
  appType?: InputMaybe<AppTypeMobile>;
  contentHTML?: InputMaybe<Scalars['String']['input']>;
  contentHTMLEn?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  showDomain?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Status>;
  style?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminUserAttemptsScoreWithAiInput = {
  attemptIds: Array<Scalars['ID']['input']>;
  forceGetScore?: Scalars['Boolean']['input'];
};

export type AdminUserTeacherReferralUsagePaysInput = {
  date: Scalars['DateTime']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type AdminViewerActivationCodeCreateInput = {
  aiSpeakingCount?: InputMaybe<Scalars['Int']['input']>;
  aiWritingCount?: InputMaybe<Scalars['Int']['input']>;
  diamond?: InputMaybe<Scalars['Int']['input']>;
  isJoinClass?: InputMaybe<Scalars['Boolean']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  oneTime?: InputMaybe<Scalars['Boolean']['input']>;
  packageID: Scalars['ID']['input'];
  planDay?: InputMaybe<Scalars['Duration']['input']>;
  type: ActivationCodeType;
};

export type AdminViewerActivationCodeUpdateInput = {
  id: Scalars['ID']['input'];
  isJoinClass?: InputMaybe<Scalars['Boolean']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  oneTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminViewerActiveCodeJoinClassInput = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdminViewerActiveCodeToUserInput = {
  code: Scalars['String']['input'];
  identify: Scalars['String']['input'];
};

export type AdminViewerBingoSubjectCreateInput = {
  addBingoSubjectImages?: InputMaybe<Array<BingoSubjectImageCreateInput>>;
  appTypes?: InputMaybe<Array<AppType>>;
  boardShow?: InputMaybe<BingoSubjectBoardShow>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['String']['input'];
  level?: InputMaybe<CefrLevel>;
  promptAi: Scalars['String']['input'];
  rawTopic?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  titleEn: Scalars['String']['input'];
  topicId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminViewerBingoSubjectDeleteInput = {
  id: Scalars['ID']['input'];
};

export type AdminViewerBingoSubjectUpdateInput = {
  addBingoSubjectImages?: InputMaybe<Array<BingoSubjectImageCreateInput>>;
  appTypes?: InputMaybe<Array<AppType>>;
  boardShow?: InputMaybe<BingoSubjectBoardShow>;
  deleteBingoSubjectImages?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<CefrLevel>;
  promptAi?: InputMaybe<Scalars['String']['input']>;
  rawTopic?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
  topicId?: InputMaybe<Scalars['ID']['input']>;
  updateBingoSubjectImages?: InputMaybe<Array<BingoSubjectImageUpdateInput>>;
};

export type AdminViewerCheckPointReviewRequestUpdateInput = {
  id: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonEn?: InputMaybe<Scalars['String']['input']>;
  status: CheckPointReviewRequestStatus;
};

export type AdminViewerFeatureDefaultCreateInput = {
  appType?: InputMaybe<AppTypeMobile>;
  code?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type AdminViewerFeatureDefaultUpdateInput = {
  appType?: InputMaybe<AppTypeMobile>;
  code?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type AdminViewerFeatureSetCreateInput = {
  customDomainId?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  featureDefaultId?: InputMaybe<Scalars['ID']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminViewerFeatureSetUpdateInput = {
  customDomainId?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  featureDefaultId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  schoolId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminViewerFeaturedPlaylistCheckPointAddInput = {
  checkPointIds: Array<Scalars['ID']['input']>;
  featuredPlaylistId: Scalars['ID']['input'];
};

export type AdminViewerFeaturedPlaylistCheckPointRemoveInput = {
  checkPointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featuredPlaylistId: Scalars['ID']['input'];
};

export type AdminViewerFeaturedPlaylistCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  levels: Array<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishMode?: InputMaybe<FeaturedPlaylistPublishMode>;
  title: Scalars['String']['input'];
  titleEn: Scalars['String']['input'];
};

export type AdminViewerFeaturedPlaylistUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<Scalars['String']['input']>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishMode?: InputMaybe<FeaturedPlaylistPublishMode>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
};

export type AdminViewerLearningOutcomeSubjectCreateInput = {
  bingoSubjectId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  titleEn: Scalars['String']['input'];
};

export type AdminViewerLearningOutcomeSubjectDeleteInput = {
  id: Scalars['ID']['input'];
};

export type AdminViewerLearningOutcomeSubjectUpdateInput = {
  bingoSubjectId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
};

export type AdminViewerMenuNotificationCreateInput = {
  contentEn: Scalars['String']['input'];
  contentVi: Scalars['String']['input'];
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionVi?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  layout?: InputMaybe<MenuNotificationLayout>;
  menuCode: Scalars['String']['input'];
  titleEn?: InputMaybe<Scalars['String']['input']>;
  titleVi?: InputMaybe<Scalars['String']['input']>;
  type: MenuNotificationType;
  version: Scalars['String']['input'];
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminViewerMenuNotificationUpdateInput = {
  contentEn?: InputMaybe<Scalars['String']['input']>;
  contentVi?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionVi?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  layout?: InputMaybe<MenuNotificationLayout>;
  menuCode?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
  titleVi?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MenuNotificationType>;
  version?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminViewerRevokeActiveCodeInput = {
  code: Array<Scalars['String']['input']>;
};

export type AdminViewerSchoolCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  adminIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customDomainId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  onlineClass?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<SchoolStatus>;
  studentLimit?: InputMaybe<Scalars['Int']['input']>;
  teacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userMaxSessions?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminViewerSchoolUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  adminIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customDomainId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  onlineClass?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<SchoolStatus>;
  studentLimit?: InputMaybe<Scalars['Int']['input']>;
  teacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userMaxSessions?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminViewerThemesCreateInput = {
  backgroundId?: InputMaybe<Scalars['String']['input']>;
  bingoId?: InputMaybe<Scalars['String']['input']>;
  blockLeft?: InputMaybe<Scalars['String']['input']>;
  blockRight?: InputMaybe<Scalars['String']['input']>;
  bookOneId?: InputMaybe<Scalars['String']['input']>;
  bookTwoId?: InputMaybe<Scalars['String']['input']>;
  borderProgress?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  iconLeftId?: InputMaybe<Scalars['String']['input']>;
  iconNextId?: InputMaybe<Scalars['String']['input']>;
  iconPrevId?: InputMaybe<Scalars['String']['input']>;
  iconRightId?: InputMaybe<Scalars['String']['input']>;
  iconZoomId?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  imagePreviewId?: InputMaybe<Scalars['String']['input']>;
  imageTitleId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
  progressColor?: InputMaybe<Scalars['String']['input']>;
  progressId?: InputMaybe<Scalars['String']['input']>;
  type: ThemeType;
};

export type AdminViewerThemesUpdateInput = {
  backgroundId?: InputMaybe<Scalars['String']['input']>;
  bingoId?: InputMaybe<Scalars['String']['input']>;
  blockLeft?: InputMaybe<Scalars['String']['input']>;
  blockRight?: InputMaybe<Scalars['String']['input']>;
  bookOneId?: InputMaybe<Scalars['String']['input']>;
  bookTwoId?: InputMaybe<Scalars['String']['input']>;
  borderProgress?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  iconLeftId?: InputMaybe<Scalars['String']['input']>;
  iconNextId?: InputMaybe<Scalars['String']['input']>;
  iconPrevId?: InputMaybe<Scalars['String']['input']>;
  iconRightId?: InputMaybe<Scalars['String']['input']>;
  iconZoomId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  imagePreviewId?: InputMaybe<Scalars['String']['input']>;
  imageTitleId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  progressColor?: InputMaybe<Scalars['String']['input']>;
  progressId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ThemeType>;
};

export type AdminVocabWordCreateInput = {
  level?: InputMaybe<CefrLevel>;
  phonetics: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type AdminVocabWordUpdateInput = {
  id: Scalars['ID']['input'];
  level?: InputMaybe<CefrLevel>;
  phonetics?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type AdminWritingPartCreateInput = {
  aiPrompt?: InputMaybe<WritingAiPromptInput>;
  body?: InputMaybe<WritingPartBodyInput>;
  name: Scalars['String']['input'];
  time?: InputMaybe<Scalars['Duration']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminWritingPartUpdateInput = {
  aiPrompt?: InputMaybe<WritingAiPromptInput>;
  body?: InputMaybe<WritingPartBodyInput>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum AdviceAdviceType {
  FlyerPackage = 'FLYER_PACKAGE',
  OutCheckout = 'OUT_CHECKOUT'
}

export enum AdviceSource {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export enum AdviceStatus {
  Done = 'DONE',
  Hold = 'HOLD',
  New = 'NEW',
  Process = 'PROCESS'
}

export enum Alignment {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export enum AppType {
  Bingo = 'BINGO',
  Exam = 'EXAM',
  Ielts = 'IELTS'
}

export enum AppTypeMobile {
  ExamWeb = 'EXAM_WEB',
  Ielts = 'IELTS',
  IeltsWeb = 'IELTS_WEB',
  Parent = 'PARENT',
  PartnerWeb = 'PARTNER_WEB',
  Student = 'STUDENT',
  StudyApp = 'STUDY_APP',
  StudyWeb = 'STUDY_WEB',
  Teacher = 'TEACHER'
}

export enum AssignTestAssignType {
  BingoSubject = 'BINGO_SUBJECT',
  CheckPoint = 'CHECK_POINT',
  ExternalLink = 'EXTERNAL_LINK'
}

export type AssignTestClassFilter = {
  and?: InputMaybe<Array<AssignTestClassFilter>>;
  assignTestId?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasClassWith?: InputMaybe<ClassFilter>;
  or?: InputMaybe<Array<AssignTestClassFilter>>;
};

export type AssignTestFilter = {
  and?: InputMaybe<Array<AssignTestFilter>>;
  assignType?: InputMaybe<Array<AssignTestAssignType>>;
  classIds?: InputMaybe<Array<Scalars['String']['input']>>;
  classScheduleLessonId?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByType?: InputMaybe<Array<CreatedByAssignTest>>;
  endDate?: InputMaybe<DateTimeRange>;
  hasAssignTestProfilesWith?: InputMaybe<AssignTestProfileFilter>;
  hasCheckPointWith?: InputMaybe<CheckPointFilter>;
  hasIelts?: InputMaybe<Scalars['Boolean']['input']>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  hasTestLevelWith?: InputMaybe<TestLevelFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<AssignTestFilter>>;
  startDate?: InputMaybe<DateTimeRange>;
  status?: InputMaybe<Array<StatusAssignTest>>;
  studentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignTestOrder = {
  key?: InputMaybe<AssignTestOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AssignTestOrderKey {
  BingoSubjectTitleEn = 'BINGO_SUBJECT_TITLE_EN',
  BingoSubjectTitleVi = 'BINGO_SUBJECT_TITLE_VI',
  CheckPointNameEn = 'CHECK_POINT_NAME_EN',
  CheckPointNameVi = 'CHECK_POINT_NAME_VI',
  CheckPointType = 'CHECK_POINT_TYPE',
  EndDate = 'END_DATE',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  TestLevelName = 'TEST_LEVEL_NAME'
}

export type AssignTestProfileFilter = {
  and?: InputMaybe<Array<AssignTestProfileFilter>>;
  assignTestId?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasAssignTestWith?: InputMaybe<AssignTestFilter>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  highestGrade?: InputMaybe<FloatRange>;
  learnerProfileId?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<AssignTestProfileFilter>>;
  redoing?: InputMaybe<Scalars['Boolean']['input']>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignTestProfileOrder = {
  key?: InputMaybe<AssignTestProfileOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AssignTestProfileOrderKey {
  HighestGrade = 'HIGHEST_GRADE'
}

export type AudioAwsFilter = {
  duration?: InputMaybe<IntRange>;
  size?: InputMaybe<IntRange>;
};

export enum AuthOtpFlow {
  RecoverPassword = 'RECOVER_PASSWORD',
  SignUp = 'SIGN_UP'
}

export type AutoTestUserCreatePayloadInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  leanerProfileName?: InputMaybe<Scalars['String']['input']>;
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
  teacherProfileName?: InputMaybe<Scalars['String']['input']>;
  userMaxProfiles?: InputMaybe<Scalars['Int']['input']>;
  userMaxSessions?: InputMaybe<Scalars['Int']['input']>;
  username: Scalars['String']['input'];
};

export type AutoTestUserUpdatePayloadInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
  userMaxProfiles?: InputMaybe<Scalars['Int']['input']>;
  userMaxSessions?: InputMaybe<Scalars['Int']['input']>;
};

export type AvatarFrameCreateInput = {
  imageId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AvatarFrameType>;
};

export type AvatarFrameFilter = {
  nameEnQ?: InputMaybe<Array<Scalars['String']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<AvatarFrameType>>;
};

export enum AvatarFrameType {
  Avatar = 'AVATAR',
  Frame = 'FRAME'
}

export type AvatarFrameUpdateInput = {
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AvatarFrameType>;
};

export type BankAccountInfoInput = {
  accountNumber: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
};

export type BingoDeviceFilter = {
  /** Remote lock state. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<BingoDeviceFilter>>;
  /** Exact board type, any of, e.g. "xingzhi-cube-1.54tft-wifi". */
  deviceType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Case-insensitive substring search on board type, matches any of. */
  deviceTypeQ?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exact firmware version the device last reported, any of. */
  firmwareVersion?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Case-insensitive substring search on reported firmware version, matches any of. */
  firmwareVersionQ?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exact MAC, any of. MACs are stored lower-case, so match the casing. */
  mac?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Case-insensitive substring search on MAC, matches any of — for a partial MAC off a support ticket. */
  macQ?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<BingoDeviceFilter>>;
  /** False lists exactly the devices held back from OTA — the roll-out worklist. */
  otaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BingoStudyChallengeAnswerInput = {
  choice?: InputMaybe<BingoStudyOptionInput>;
  choices?: InputMaybe<Array<BingoStudyOptionInput>>;
  markedCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  pair?: InputMaybe<BingoStudyPairInput>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordText?: InputMaybe<Scalars['String']['input']>;
  subChallengeId?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  unspeakable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BingoStudyChallengeInput = {
  choices?: InputMaybe<Array<BingoStudyOptionInput>>;
  evaluationCriteria?: InputMaybe<PracticePartEvaluationCriteriaInput>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  isHidingPlaceholderAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  maximumWordsAnswer?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Array<PracticePartNoteInput>>;
  pairs?: InputMaybe<Array<BingoStudyPairInput>>;
  prompts?: InputMaybe<Array<BingoStudyPromptInput>>;
  subChallengeId?: InputMaybe<Scalars['ID']['input']>;
  subChallenges?: InputMaybe<Array<BingoStudyChallengeInput>>;
  textSolutions?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: BingoStudyChallengeType;
  videoEndTime?: InputMaybe<Scalars['Float']['input']>;
  videoStartTime?: InputMaybe<Scalars['Float']['input']>;
  videoTimestamp?: InputMaybe<Scalars['Float']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum BingoStudyChallengeType {
  Assist = 'ASSIST',
  Dialogue = 'DIALOGUE',
  DragDrop = 'DRAG_DROP',
  FillLetter = 'FILL_LETTER',
  Flashcards = 'FLASHCARDS',
  FlashcardsFill = 'FLASHCARDS_FILL',
  ImageFill = 'IMAGE_FILL',
  ImageMatch = 'IMAGE_MATCH',
  ImageSelect = 'IMAGE_SELECT',
  ImageSpeak = 'IMAGE_SPEAK',
  ImageTap = 'IMAGE_TAP',
  ImageTapComplete = 'IMAGE_TAP_COMPLETE',
  InteractiveVideo = 'INTERACTIVE_VIDEO',
  Listen = 'LISTEN',
  ListenIsolation = 'LISTEN_ISOLATION',
  ListenMatch = 'LISTEN_MATCH',
  ListenTap = 'LISTEN_TAP',
  Match = 'MATCH',
  OpenEnded = 'OPEN_ENDED',
  Select = 'SELECT',
  SelectObject = 'SELECT_OBJECT',
  SelectTranscription = 'SELECT_TRANSCRIPTION',
  Speak = 'SPEAK',
  StoryTap = 'STORY_TAP',
  StoryTapComplete = 'STORY_TAP_COMPLETE',
  TapComplete = 'TAP_COMPLETE',
  Translate = 'TRANSLATE',
  TranslateTap = 'TRANSLATE_TAP',
  TrueFalse = 'TRUE_FALSE',
  WordOrdering = 'WORD_ORDERING',
  YesNo = 'YES_NO'
}

export type BingoStudyCharacterInput = {
  imageId?: InputMaybe<Scalars['ID']['input']>;
};

export type BingoStudyEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type BingoStudyImagePlaceholderInput = {
  height?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  left: Scalars['String']['input'];
  top: Scalars['String']['input'];
  width?: InputMaybe<Scalars['String']['input']>;
};

export enum BingoStudyLevelSessionObjectiveKey {
  CompleteIn_5Min = 'COMPLETE_IN_5_MIN',
  ExactThreeFirstTry = 'EXACT_THREE_FIRST_TRY'
}

export enum BingoStudyLevelType {
  BingoSubject = 'BINGO_SUBJECT',
  Chest = 'CHEST',
  Regular = 'REGULAR'
}

export type BingoStudyOptionInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  correctPlaceholderId?: InputMaybe<Scalars['ID']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  isDistractor?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  top?: InputMaybe<Scalars['String']['input']>;
  unselectable?: InputMaybe<Scalars['Boolean']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type BingoStudyPairInput = {
  from: BingoStudyOptionInput;
  to: BingoStudyOptionInput;
};

export type BingoStudyPartAnswerInput = {
  challenge?: InputMaybe<BingoStudyChallengeAnswerInput>;
  story?: InputMaybe<BingoStudyStoryAnswerInput>;
};

export type BingoStudyPartFilter = {
  challengeTypes?: InputMaybe<Array<BingoStudyChallengeType>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  mode?: InputMaybe<BingoStudyPartMode>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  partTypes?: InputMaybe<Array<BingoStudyPartType>>;
};

export enum BingoStudyPartMode {
  Challenge = 'CHALLENGE',
  Story = 'STORY'
}

export enum BingoStudyPartType {
  DragDrop = 'DRAG_DROP',
  FillInBlank = 'FILL_IN_BLANK',
  FillLetter = 'FILL_LETTER',
  Flashcard = 'FLASHCARD',
  GapFill = 'GAP_FILL',
  InteractiveVideo = 'INTERACTIVE_VIDEO',
  Matching = 'MATCHING',
  MultipleChoice = 'MULTIPLE_CHOICE',
  OpenEnded = 'OPEN_ENDED',
  ScrambledSentence = 'SCRAMBLED_SENTENCE',
  SelectObject = 'SELECT_OBJECT',
  Speaking = 'SPEAKING',
  Story = 'STORY',
  WordOrdering = 'WORD_ORDERING'
}

export type BingoStudyPromptInput = {
  alignment?: InputMaybe<Alignment>;
  audioId?: InputMaybe<Scalars['ID']['input']>;
  character?: InputMaybe<BingoStudyCharacterInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  imageAlignment?: InputMaybe<Alignment>;
  imageAudioId?: InputMaybe<Scalars['ID']['input']>;
  imageContent?: InputMaybe<Scalars['String']['input']>;
  imageDescription?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  imagePlaceholders?: InputMaybe<Array<BingoStudyImagePlaceholderInput>>;
  showCharacter?: InputMaybe<Scalars['Boolean']['input']>;
  slowAudioId?: InputMaybe<Scalars['ID']['input']>;
  tokens?: InputMaybe<Array<BingoStudyTokenInput>>;
  zoomedImageId?: InputMaybe<Scalars['ID']['input']>;
};

export type BingoStudyStartAttemptInput = {
  assignTestID?: InputMaybe<Scalars['ID']['input']>;
  bookLessonId?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  level?: InputMaybe<Scalars['ID']['input']>;
  objectives?: InputMaybe<Array<UserAttemptObjectiveKey>>;
};

export type BingoStudyStoryAnswerInput = {
  choice?: InputMaybe<BingoStudyOptionInput>;
  choices?: InputMaybe<Array<BingoStudyOptionInput>>;
  elementIndex: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type BingoStudyStoryElementInput = {
  line?: InputMaybe<BingoStudyPromptInput>;
  question?: InputMaybe<BingoStudyStoryQuestionInput>;
  type: BingoStudyStoryElementType;
};

export enum BingoStudyStoryElementType {
  GapFill = 'GAP_FILL',
  Header = 'HEADER',
  Line = 'LINE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  PointToPhrase = 'POINT_TO_PHRASE',
  SelectPhrase = 'SELECT_PHRASE'
}

export type BingoStudyStoryInput = {
  elements: Array<BingoStudyStoryElementInput>;
};

export type BingoStudyStoryQuestionInput = {
  choices?: InputMaybe<Array<BingoStudyOptionInput>>;
  textSolutions?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BingoStudySubmitPartAttemptInput = {
  answer: BingoStudyPartAnswerInput;
  attemptId: Scalars['ID']['input'];
  partId: Scalars['ID']['input'];
};

export type BingoStudyTokenInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<BingoStudyTokenRowInput>>;
  token: Scalars['String']['input'];
};

export type BingoStudyTokenRowInput = {
  hint: Scalars['String']['input'];
};

export enum BingoSubjectBoardShow {
  Bingo = 'BINGO',
  Study = 'STUDY'
}

export type BingoSubjectFilter = {
  and?: InputMaybe<Array<BingoSubjectFilter>>;
  appTypes?: InputMaybe<Array<AppType>>;
  boardShow?: InputMaybe<Array<BingoSubjectBoardShow>>;
  byAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  hasTopicWith?: InputMaybe<TopicFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  level?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<BingoSubjectFilter>>;
  source?: InputMaybe<Array<SourceBingo>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  titleEnQ?: InputMaybe<Array<Scalars['String']['input']>>;
  titleQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BingoSubjectImageCreateInput = {
  bingoSubjectId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
};

export type BingoSubjectImageUpdateInput = {
  bingoSubjectId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
};

export type BingoSubjectOrder = {
  key?: InputMaybe<BingoSubjectOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BingoSubjectOrderKey {
  StudentCount = 'STUDENT_COUNT',
  TitleEnOrder = 'TITLE_EN_ORDER',
  TitleOrder = 'TITLE_ORDER'
}

export type BookFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  levels?: InputMaybe<Array<CefrLevel>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<BookStatus>>;
};

export type BookLessonCheckPointInput = {
  bingoSubjectId?: InputMaybe<Scalars['ID']['input']>;
  checkPointId?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
};

export type BookLessonFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BookLessonOrder = {
  key?: InputMaybe<BookLessonOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BookLessonOrderKey {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION'
}

export type BookLessonSubjectRemoveInput = {
  bingoSubjectId?: InputMaybe<Scalars['ID']['input']>;
  checkPointId?: InputMaybe<Scalars['ID']['input']>;
};

export type BookLessonSubjectUpdateInput = {
  bingoSubjectId?: InputMaybe<Scalars['ID']['input']>;
  checkPointId?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
};

export enum BookStatus {
  Domain = 'DOMAIN',
  Global = 'GLOBAL',
  Private = 'PRIVATE',
  School = 'SCHOOL'
}

export type BookUnitFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BookUnitUpdateLessonInput = {
  lessonId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type BookUpdateUnitInput = {
  position: Scalars['Int']['input'];
  unitId: Scalars['ID']['input'];
};

export enum CalendarEventEventType {
  Assignment = 'ASSIGNMENT',
  Meeting = 'MEETING'
}

export type CalendarEventFilter = {
  and?: InputMaybe<Array<CalendarEventFilter>>;
  endDate?: InputMaybe<DateTimeRange>;
  eventType?: InputMaybe<Array<CalendarEventEventType>>;
  hasAssignTestWith?: InputMaybe<AssignTestFilter>;
  hasCalendarEventTimesWith?: InputMaybe<CalendarEventTimeFilter>;
  hasClassWith?: InputMaybe<ClassFilter>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<CalendarEventFilter>>;
  startDate?: InputMaybe<DateTimeRange>;
  timetableId?: InputMaybe<Array<Scalars['ID']['input']>>;
  view?: InputMaybe<CalendarEventFilterView>;
};

export enum CalendarEventFilterView {
  Self = 'SELF'
}

export enum CalendarEventTimeAttendanceStatus {
  /** Đã hoàn tất. */
  Completed = 'COMPLETED',
  /** Đã đánh dấu ít nhất một học sinh nhưng giáo viên chưa bấm hoàn tất. */
  InProgress = 'IN_PROGRESS',
  /** Chưa học sinh nào được đánh dấu trên buổi này. */
  NotTaken = 'NOT_TAKEN'
}

export type CalendarEventTimeFilter = {
  and?: InputMaybe<Array<CalendarEventTimeFilter>>;
  endAt?: InputMaybe<DateTimeRange>;
  hasCalendarEventWith?: InputMaybe<CalendarEventFilter>;
  or?: InputMaybe<Array<CalendarEventTimeFilter>>;
  startAt?: InputMaybe<DateTimeRange>;
};

export enum CalendarEventTimeStatus {
  Cancelled = 'CANCELLED',
  Normal = 'NORMAL',
  Rescheduled = 'RESCHEDULED'
}

export enum CefrLevel {
  A1 = 'a1',
  A2 = 'a2',
  B1 = 'b1',
  B2 = 'b2',
  C1 = 'c1',
  C2 = 'c2',
  Prea1 = 'prea1'
}

export type ChallengeCreateInput = {
  checkPointId: Scalars['ID']['input'];
  disabledPassword?: InputMaybe<Scalars['Boolean']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenName?: InputMaybe<Scalars['Boolean']['input']>;
  isLimit?: InputMaybe<Scalars['Boolean']['input']>;
  isMixed?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<ChallengeSettingsInput>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ChallengeEndInput = {
  challengeId: Scalars['ID']['input'];
};

export type ChallengeFilter = {
  activityStatus?: InputMaybe<Array<ActivityStatusChallenge>>;
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  hasCheckPointWith?: InputMaybe<CheckPointFilter>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<ChallengeFilter>>;
};

export type ChallengeOrder = {
  key?: InputMaybe<ChallengeOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ChallengeOrderKey {
  Levels = 'LEVELS',
  TotalPlayers = 'TOTAL_PLAYERS'
}

export type ChallengePlayerFilter = {
  hasChallengeWith?: InputMaybe<ChallengeFilter>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
};

export type ChallengePlayerJoinInput = {
  challengeId: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeSettingsInput = {
  sound: Scalars['Boolean']['input'];
};

export type ChallengeStartInput = {
  challengeId: Scalars['ID']['input'];
};

export type ChallengeUpdateInput = {
  disabledPassword?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type CheckPointCustomDomainFilter = {
  and?: InputMaybe<Array<CheckPointCustomDomainFilter>>;
  domainName?: InputMaybe<Array<Scalars['String']['input']>>;
  domainNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSchoolsWith?: InputMaybe<SchoolFilter>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CheckPointCustomDomainFilter>;
  or?: InputMaybe<Array<CheckPointCustomDomainFilter>>;
  status?: InputMaybe<Array<CustomDomainStatus>>;
};

export type CheckPointExamPartFilter = {
  not?: InputMaybe<CheckPointExamPartFilter>;
  order?: InputMaybe<IntRange>;
  partType?: InputMaybe<Array<ExamPartType>>;
};

export type CheckPointFilter = {
  ID?: InputMaybe<Array<Scalars['ID']['input']>>;
  and?: InputMaybe<Array<CheckPointFilter>>;
  attemptsAllowed?: InputMaybe<IntRange>;
  cpType?: InputMaybe<Array<CheckPointType>>;
  domains?: InputMaybe<Array<Scalars['ID']['input']>>;
  forPartOrder?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasCustomDomainsWith?: InputMaybe<CheckPointCustomDomainFilter>;
  hasDomains?: InputMaybe<Scalars['Boolean']['input']>;
  hasExamPartsWith?: InputMaybe<CheckPointExamPartFilter>;
  hasFeaturedPlaylistCheckPointsWith?: InputMaybe<FeaturedPlaylistCheckPointFilter>;
  hasIeltsNotesWith?: InputMaybe<IeltsNoteFilter>;
  hasIeltsQuestionDetailTypes?: InputMaybe<Array<IeltsDetailType>>;
  hasInteractiveVideo?: InputMaybe<Scalars['Boolean']['input']>;
  hasSpeakingPartsWith?: InputMaybe<CheckPointSpeakingPartFilter>;
  hasTestLevelWith?: InputMaybe<TestLevelFilter>;
  hasTopicsWith?: InputMaybe<CheckPointTopicFilter>;
  ieltsBand?: InputMaybe<FloatRange>;
  isMixed?: InputMaybe<Scalars['Boolean']['input']>;
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  nameEn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nameEnQ?: InputMaybe<Array<Scalars['String']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<CheckPointFilter>;
  or?: InputMaybe<Array<CheckPointFilter>>;
  publicStatus?: InputMaybe<Array<CheckPointPublicStatus>>;
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  source?: InputMaybe<Array<Scalars['String']['input']>>;
  sourcePlacementTestExam?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceSchool?: InputMaybe<SourceSchool>;
  status?: InputMaybe<Array<CheckPointStatus>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  testLevelId?: InputMaybe<Array<Scalars['ID']['input']>>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<DurationRange>;
  type?: InputMaybe<Array<Scalars['CheckPointTypeV1']['input']>>;
  viewerCanAccess?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckPointIeltsListeningPartInput = {
  partId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type CheckPointIeltsReadingPartInput = {
  partId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type CheckPointIeltsSpeakingPartInput = {
  partId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type CheckPointIeltsWritingPartInput = {
  partId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type CheckPointInteractiveVideoInput = {
  notes?: InputMaybe<Array<PracticePartNoteInput>>;
  videoEndTime?: InputMaybe<Scalars['Float']['input']>;
  videoStartTime?: InputMaybe<Scalars['Float']['input']>;
  videoUrl: Scalars['String']['input'];
};

export type CheckPointOrder = {
  key?: InputMaybe<CheckPointOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CheckPointOrderKey {
  AdminRank = 'ADMIN_RANK',
  NameEnOrder = 'NAME_EN_ORDER',
  NameOrder = 'NAME_ORDER',
  TestCount = 'TEST_COUNT',
  TestLevelOrder = 'TEST_LEVEL_ORDER',
  TypePosition = 'TYPE_POSITION'
}

export enum CheckPointPublicStatus {
  Community = 'COMMUNITY',
  UserCommunity = 'USER_COMMUNITY'
}

export type CheckPointReviewRequestFilter = {
  and?: InputMaybe<Array<CheckPointReviewRequestFilter>>;
  hasBookWith?: InputMaybe<BookFilter>;
  hasCheckPointWith?: InputMaybe<CheckPointFilter>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  not?: InputMaybe<CheckPointReviewRequestFilter>;
  or?: InputMaybe<Array<CheckPointReviewRequestFilter>>;
  status?: InputMaybe<Array<CheckPointReviewRequestStatus>>;
  type?: InputMaybe<Array<CheckPointReviewRequestType>>;
};

export enum CheckPointReviewRequestStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum CheckPointReviewRequestType {
  Book = 'BOOK',
  Checkpoint = 'CHECKPOINT'
}

export type CheckPointSpeakingPartFilter = {
  not?: InputMaybe<CheckPointSpeakingPartFilter>;
  order?: InputMaybe<IntRange>;
  partType?: InputMaybe<Array<SpeakingPartType>>;
};

export type CheckPointSpeakingPartInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  partId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export enum CheckPointStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type CheckPointTimeUpdateInput = {
  checkpointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  partId?: InputMaybe<Scalars['ID']['input']>;
  typeCheckpoint: TypeCheckPointAdmin;
};

export type CheckPointTopicFilter = {
  and?: InputMaybe<Array<CheckPointTopicFilter>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameEnQ?: InputMaybe<Array<Scalars['String']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<CheckPointTopicFilter>;
  or?: InputMaybe<Array<CheckPointTopicFilter>>;
};

export enum CheckPointType {
  Normal = 'NORMAL',
  PlacementTest = 'PLACEMENT_TEST'
}

export type CheckPointWritingPartInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  partId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassAssignedTeacherFilter = {
  id: Array<Scalars['ID']['input']>;
  q?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClassFilter = {
  classLevelId?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<DateTimeRange>;
  hasAssignedTeachersWith?: InputMaybe<ClassAssignedTeacherFilter>;
  hasSchoolWith?: InputMaybe<SchoolFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<ClassType>>;
};

export type ClassOrder = {
  key?: InputMaybe<ClassOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ClassOrderKey {
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  LevelName = 'LEVEL_NAME',
  Name = 'NAME',
  Pin = 'PIN',
  Type = 'TYPE'
}

export type ClassScheduleLessonSessionRollupStudentFilter = {
  statuses?: InputMaybe<Array<ClassScheduleLessonSessionStudentStatus>>;
};

export enum ClassScheduleLessonSessionStudentStatus {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export enum ClassScheduleLessonStatus {
  NotStarted = 'NOT_STARTED',
  Reminded = 'REMINDED'
}

export enum ClassScheduleProgramType {
  Book = 'BOOK',
  Study = 'STUDY'
}

export type ClassScheduleRollupLessonFilter = {
  statuses?: InputMaybe<Array<ClassScheduleLessonStatus>>;
};

export type ClassScheduleRollupLessonOrder = {
  direction: OrderDirection;
  key: ClassScheduleRollupLessonOrderKey;
};

export enum ClassScheduleRollupLessonOrderKey {
  Position = 'POSITION'
}

export type ClassStudentFilter = {
  classID?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasClassWith?: InputMaybe<ClassFilter>;
  q?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClassStudentOrder = {
  key?: InputMaybe<ClassStudentOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ClassStudentOrderKey {
  ClassName = 'CLASS_NAME',
  JoinedDate = 'JOINED_DATE',
  StudentDateOfBirth = 'STUDENT_DATE_OF_BIRTH',
  StudentDisplayName = 'STUDENT_DISPLAY_NAME'
}

export enum ClassType {
  Classic = 'CLASSIC',
  Ielts = 'IELTS',
  PlacementTest = 'PLACEMENT_TEST'
}

export type CoherenceAndCohesionBreakdownInput = {
  clarityAndProgression?: InputMaybe<StandardFeedbackInput>;
  paragraphing?: InputMaybe<StandardFeedbackInput>;
  referenceAndSubstitution?: InputMaybe<StandardFeedbackInput>;
  useOfCohesiveDevices?: InputMaybe<StandardFeedbackInput>;
};

export type CreateTeacherProfileAdminInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export enum CreatedByAssignTest {
  Parent = 'PARENT',
  Teacher = 'TEACHER'
}

export type CriterionInput = {
  commentary?: InputMaybe<Scalars['String']['input']>;
  criterion?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomDomainFilter = {
  domainNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSchoolsWith?: InputMaybe<SchoolFilter>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  rejectedDomainNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<CustomDomainStatus>>;
};

export enum CustomDomainStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type DateRangeInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type DateTimeRange = {
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DetailedFeedbackInput = {
  coherenceAndCohesionBreakdown?: InputMaybe<CoherenceAndCohesionBreakdownInput>;
  grammaticalRangeAndAccuracyBreakdown?: InputMaybe<GrammaticalRangeAndAccuracyBreakdownInput>;
  lexicalResourceBreakdown?: InputMaybe<LexicalResourceBreakdownInput>;
  overallScore?: InputMaybe<OverallScoreInput>;
  taskAchievementBreakdown?: InputMaybe<TaskAchievementBreakdownInput>;
  taskResponseBreakdown?: InputMaybe<TaskResponseBreakdownInput>;
};

export enum Device {
  Esp32V1 = 'ESP32_V1',
  MobileExam = 'MOBILE_EXAM',
  MobileIelts = 'MOBILE_IELTS',
  MobileStudy = 'MOBILE_STUDY',
  MobileTeacher = 'MOBILE_TEACHER',
  WebAdmin = 'WEB_ADMIN',
  WebExam = 'WEB_EXAM',
  WebIelts = 'WEB_IELTS',
  WebParent = 'WEB_PARENT',
  WebRanking = 'WEB_RANKING',
  WebSignUp = 'WEB_SIGN_UP',
  WebStudy = 'WEB_STUDY',
  WebTeacher = 'WEB_TEACHER'
}

export enum DeviceType {
  Bot = 'bot',
  Desktop = 'desktop',
  Mobile = 'mobile',
  Tablet = 'tablet',
  Tv = 'tv',
  Unknown = 'unknown'
}

export enum DiscountDiscountType {
  Amount = 'AMOUNT',
  Percent = 'PERCENT'
}

export enum DiscountEventType {
  Automatic = 'AUTOMATIC',
  CouponCode = 'COUPON_CODE'
}

export type DiscountFilter = {
  codeQ?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<DateTimeRange>;
  eventType?: InputMaybe<Array<DiscountEventType>>;
  sourceType?: InputMaybe<Array<DiscountSourceType>>;
  startDate?: InputMaybe<DateTimeRange>;
  status?: InputMaybe<Array<DiscountStatus>>;
};

export enum DiscountSourceType {
  Exam = 'EXAM',
  Teacher = 'TEACHER'
}

export enum DiscountStatus {
  Active = 'ACTIVE',
  InActive = 'IN_ACTIVE'
}

export type DomainDataInput = {
  examBackgroundImageID?: InputMaybe<Scalars['String']['input']>;
  examLogoImageID?: InputMaybe<Scalars['String']['input']>;
  featureDescription?: InputMaybe<Scalars['String']['input']>;
  featureImageID?: InputMaybe<Scalars['String']['input']>;
  featureTitle?: InputMaybe<Scalars['String']['input']>;
  loginTitle?: InputMaybe<Scalars['String']['input']>;
  loginTitleEn?: InputMaybe<Scalars['String']['input']>;
  logoImageID?: InputMaybe<Scalars['String']['input']>;
};

export type DuolingoChallengeAnswerInput = {
  choice?: InputMaybe<DuolingoOptionInput>;
  choices?: InputMaybe<Array<DuolingoOptionInput>>;
  markedCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  pair?: InputMaybe<DuolingoPairInput>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordText?: InputMaybe<Scalars['String']['input']>;
  subChallengeId?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  unspeakable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DuolingoChallengeInput = {
  choices?: InputMaybe<Array<DuolingoOptionInput>>;
  evaluationCriteria?: InputMaybe<PracticePartEvaluationCriteriaInput>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  isHidingPlaceholderAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  maximumWordsAnswer?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Array<PracticePartNoteInput>>;
  pairs?: InputMaybe<Array<DuolingoPairInput>>;
  prompts?: InputMaybe<Array<DuolingoPromptInput>>;
  subChallengeId?: InputMaybe<Scalars['ID']['input']>;
  subChallenges?: InputMaybe<Array<DuolingoChallengeInput>>;
  textSolutions?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: DuolingoChallengeType;
  videoEndTime?: InputMaybe<Scalars['Float']['input']>;
  videoStartTime?: InputMaybe<Scalars['Float']['input']>;
  videoTimestamp?: InputMaybe<Scalars['Float']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum DuolingoChallengeType {
  Assist = 'ASSIST',
  Dialogue = 'DIALOGUE',
  DragDrop = 'DRAG_DROP',
  FillLetter = 'FILL_LETTER',
  Flashcards = 'FLASHCARDS',
  FlashcardsFill = 'FLASHCARDS_FILL',
  ImageFill = 'IMAGE_FILL',
  ImageMatch = 'IMAGE_MATCH',
  ImageSelect = 'IMAGE_SELECT',
  ImageSpeak = 'IMAGE_SPEAK',
  ImageTap = 'IMAGE_TAP',
  ImageTapComplete = 'IMAGE_TAP_COMPLETE',
  InteractiveVideo = 'INTERACTIVE_VIDEO',
  Listen = 'LISTEN',
  ListenIsolation = 'LISTEN_ISOLATION',
  ListenMatch = 'LISTEN_MATCH',
  ListenTap = 'LISTEN_TAP',
  Match = 'MATCH',
  OpenEnded = 'OPEN_ENDED',
  Select = 'SELECT',
  SelectObject = 'SELECT_OBJECT',
  SelectTranscription = 'SELECT_TRANSCRIPTION',
  Speak = 'SPEAK',
  StoryTap = 'STORY_TAP',
  StoryTapComplete = 'STORY_TAP_COMPLETE',
  TapComplete = 'TAP_COMPLETE',
  Translate = 'TRANSLATE',
  TranslateTap = 'TRANSLATE_TAP',
  TrueFalse = 'TRUE_FALSE',
  WordOrdering = 'WORD_ORDERING',
  YesNo = 'YES_NO'
}

export type DuolingoCharacterInput = {
  imageId?: InputMaybe<Scalars['ID']['input']>;
};

export type DuolingoEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type DuolingoImagePlaceholderInput = {
  height?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  left: Scalars['String']['input'];
  top: Scalars['String']['input'];
  width?: InputMaybe<Scalars['String']['input']>;
};

export enum DuolingoLevelSessionObjectiveKey {
  CompleteIn_5Min = 'COMPLETE_IN_5_MIN',
  ExactThreeFirstTry = 'EXACT_THREE_FIRST_TRY'
}

export enum DuolingoLevelType {
  BingoSubject = 'BINGO_SUBJECT',
  Chest = 'CHEST',
  Regular = 'REGULAR'
}

export type DuolingoOptionInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  correctPlaceholderId?: InputMaybe<Scalars['ID']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  isDistractor?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  top?: InputMaybe<Scalars['String']['input']>;
  unselectable?: InputMaybe<Scalars['Boolean']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type DuolingoPairInput = {
  from: DuolingoOptionInput;
  to: DuolingoOptionInput;
};

export type DuolingoPartAnswerInput = {
  challenge?: InputMaybe<DuolingoChallengeAnswerInput>;
  story?: InputMaybe<DuolingoStoryAnswerInput>;
};

export type DuolingoPartFilter = {
  challengeTypes?: InputMaybe<Array<DuolingoChallengeType>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  mode?: InputMaybe<DuolingoPartMode>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  partTypes?: InputMaybe<Array<DuolingoPartType>>;
};

export enum DuolingoPartMode {
  Challenge = 'CHALLENGE',
  Story = 'STORY'
}

export enum DuolingoPartType {
  DragDrop = 'DRAG_DROP',
  FillInBlank = 'FILL_IN_BLANK',
  FillLetter = 'FILL_LETTER',
  Flashcard = 'FLASHCARD',
  GapFill = 'GAP_FILL',
  InteractiveVideo = 'INTERACTIVE_VIDEO',
  Matching = 'MATCHING',
  MultipleChoice = 'MULTIPLE_CHOICE',
  OpenEnded = 'OPEN_ENDED',
  ScrambledSentence = 'SCRAMBLED_SENTENCE',
  SelectObject = 'SELECT_OBJECT',
  Speaking = 'SPEAKING',
  Story = 'STORY',
  WordOrdering = 'WORD_ORDERING'
}

export type DuolingoPromptInput = {
  alignment?: InputMaybe<Alignment>;
  audioId?: InputMaybe<Scalars['ID']['input']>;
  character?: InputMaybe<DuolingoCharacterInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  imageAlignment?: InputMaybe<Alignment>;
  imageAudioId?: InputMaybe<Scalars['ID']['input']>;
  imageContent?: InputMaybe<Scalars['String']['input']>;
  imageDescription?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  imagePlaceholders?: InputMaybe<Array<DuolingoImagePlaceholderInput>>;
  showCharacter?: InputMaybe<Scalars['Boolean']['input']>;
  slowAudioId?: InputMaybe<Scalars['ID']['input']>;
  tokens?: InputMaybe<Array<DuolingoTokenInput>>;
  zoomedImageId?: InputMaybe<Scalars['ID']['input']>;
};

export type DuolingoStartAttemptInput = {
  assignTestID?: InputMaybe<Scalars['ID']['input']>;
  bookLessonId?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  level?: InputMaybe<Scalars['ID']['input']>;
  objectives?: InputMaybe<Array<UserAttemptObjectiveKey>>;
};

export type DuolingoStoryAnswerInput = {
  choice?: InputMaybe<DuolingoOptionInput>;
  choices?: InputMaybe<Array<DuolingoOptionInput>>;
  elementIndex: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type DuolingoStoryElementInput = {
  line?: InputMaybe<DuolingoPromptInput>;
  question?: InputMaybe<DuolingoStoryQuestionInput>;
  type: DuolingoStoryElementType;
};

export enum DuolingoStoryElementType {
  GapFill = 'GAP_FILL',
  Header = 'HEADER',
  Line = 'LINE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  PointToPhrase = 'POINT_TO_PHRASE',
  SelectPhrase = 'SELECT_PHRASE'
}

export type DuolingoStoryInput = {
  elements: Array<DuolingoStoryElementInput>;
};

export type DuolingoStoryQuestionInput = {
  choices?: InputMaybe<Array<DuolingoOptionInput>>;
  textSolutions?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DuolingoSubmitPartAttemptInput = {
  answer: DuolingoPartAnswerInput;
  attemptId: Scalars['ID']['input'];
  partId: Scalars['ID']['input'];
};

export type DuolingoTokenInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<DuolingoTokenRowInput>>;
  token: Scalars['String']['input'];
};

export type DuolingoTokenRowInput = {
  hint: Scalars['String']['input'];
};

export type DurationRange = {
  gt?: InputMaybe<Scalars['Duration']['input']>;
  gte?: InputMaybe<Scalars['Duration']['input']>;
  lt?: InputMaybe<Scalars['Duration']['input']>;
  lte?: InputMaybe<Scalars['Duration']['input']>;
};

export enum EnglishSkillV1 {
  Listening = 'listening',
  Reading = 'reading',
  Speaking = 'speaking',
  Writing = 'writing'
}

export type ExamEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type ExamNextStructureInput = {
  attemptId: Scalars['ID']['input'];
};

export type ExamPartBodyInput = {
  contentImageId?: InputMaybe<Scalars['String']['input']>;
  contentImagePrompt?: InputMaybe<Scalars['String']['input']>;
};

export type ExamPartContentBodyInput = {
  formattedText?: InputMaybe<ExamQuestionFormattedTextInput>;
  images?: InputMaybe<Array<ExamPartContentImageInput>>;
};

export type ExamPartContentCreateInput = {
  body: ExamPartContentBodyInput;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type ExamPartContentImageInput = {
  imageId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
};

export type ExamPartContentUpdateInput = {
  body?: InputMaybe<ExamPartContentBodyInput>;
  id: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type ExamPartFilter = {
  and?: InputMaybe<Array<ExamPartFilter>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ExamPartFilter>;
  or?: InputMaybe<Array<ExamPartFilter>>;
  partType?: InputMaybe<Array<ExamPartType>>;
  structureType?: InputMaybe<Array<ExamStructureType>>;
  titleQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ExamPartType {
  OpenEnded = 'OPEN_ENDED',
  SceneCardSpeaking = 'SCENE_CARD_SPEAKING',
  Speaking = 'SPEAKING',
  Dragdrop = 'dragdrop',
  Gapfill = 'gapfill',
  Matching = 'matching',
  Multichoice = 'multichoice',
  ScrambledSentence = 'scrambled_sentence',
  WordOrdering = 'word_ordering'
}

export type ExamQuestionBodyInput = {
  audioId?: InputMaybe<Scalars['String']['input']>;
  audioSubtitle?: InputMaybe<Scalars['String']['input']>;
  evaluationCriteria?: InputMaybe<PracticePartEvaluationCriteriaInput>;
  exampleAnswers?: InputMaybe<Array<Scalars['String']['input']>>;
  maximumWordsAnswer?: InputMaybe<Scalars['Int']['input']>;
  point?: InputMaybe<SpeakingPointInput>;
  videoPrompt?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ExamQuestionCreateInput = {
  addDetails?: InputMaybe<Array<ExamQuestionDetailCreateInput>>;
  answerExplanationHTML?: InputMaybe<Scalars['String']['input']>;
  answerExplanationHTMLEn?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<ExamQuestionBodyInput>;
  choices?: InputMaybe<Array<ExamQuestionFormattedTextInput>>;
  content?: InputMaybe<ExamQuestionFormattedTextInput>;
  detailPrefix?: InputMaybe<ExamQuestionFormattedTextInput>;
  isExample?: InputMaybe<Scalars['Boolean']['input']>;
  isHidingPlaceholderAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  titlePrefix?: InputMaybe<ExamQuestionFormattedTextInput>;
};

export type ExamQuestionDetailAnswerInput = {
  answer?: InputMaybe<ExamQuestionResultValueInput>;
  detailId: Scalars['ID']['input'];
};

export type ExamQuestionDetailBoxInput = {
  height: Scalars['String']['input'];
  left: Scalars['String']['input'];
  top: Scalars['String']['input'];
  width: Scalars['String']['input'];
};

export type ExamQuestionDetailCreateInput = {
  detail?: InputMaybe<ExamQuestionDetailValueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ExamQuestionResultValueInput>;
};

export type ExamQuestionDetailTextIndexInput = {
  index: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type ExamQuestionDetailUpdateInput = {
  detail?: InputMaybe<ExamQuestionDetailValueInput>;
  id: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ExamQuestionResultValueInput>;
};

export type ExamQuestionDetailValueInput = {
  box?: InputMaybe<ExamQuestionDetailBoxInput>;
  formattedText?: InputMaybe<ExamQuestionFormattedTextInput>;
  textIndexes?: InputMaybe<Array<ExamQuestionDetailTextIndexInput>>;
};

export enum ExamQuestionDetailValueType {
  Box = 'BOX',
  FormattedText = 'FORMATTED_TEXT',
  TextIndexes = 'TEXT_INDEXES'
}

export type ExamQuestionFormattedTextInput = {
  format: ExamQuestionTextFormat;
  isDistractor?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  metadataText?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type ExamQuestionResultValueInput = {
  formattedValue?: InputMaybe<ExamQuestionFormattedTextInput>;
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  recordId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ExamQuestionResultValueType {
  EvaluationAnalysis = 'EVALUATION_ANALYSIS',
  FormattedValue = 'FORMATTED_VALUE',
  IsSelected = 'IS_SELECTED',
  Record = 'RECORD',
  Value = 'VALUE'
}

export enum ExamQuestionTextFormat {
  AudioId = 'AUDIO_ID',
  Color = 'COLOR',
  Html = 'HTML',
  ImageId = 'IMAGE_ID',
  Text = 'TEXT'
}

export type ExamQuestionUpdateInput = {
  addDetails?: InputMaybe<Array<ExamQuestionDetailCreateInput>>;
  answerExplanationHTML?: InputMaybe<Scalars['String']['input']>;
  answerExplanationHTMLEn?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<ExamQuestionBodyInput>;
  choices?: InputMaybe<Array<ExamQuestionFormattedTextInput>>;
  content?: InputMaybe<ExamQuestionFormattedTextInput>;
  deleteDetails?: InputMaybe<Array<Scalars['ID']['input']>>;
  detailPrefix?: InputMaybe<ExamQuestionFormattedTextInput>;
  id: Scalars['ID']['input'];
  isExample?: InputMaybe<Scalars['Boolean']['input']>;
  isHidingPlaceholderAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titlePrefix?: InputMaybe<ExamQuestionFormattedTextInput>;
  updateDetails?: InputMaybe<Array<ExamQuestionDetailUpdateInput>>;
};

export type ExamStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  bookLessonId?: InputMaybe<Scalars['ID']['input']>;
  challengeCode?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  teacherInvitation?: InputMaybe<TeacherInvitationInput>;
};

export enum ExamStructureType {
  Listening = 'listening',
  ReadingWriting = 'reading_writing',
  Speaking = 'speaking'
}

export type ExamSubmitPartAttemptInput = {
  attemptId: Scalars['ID']['input'];
  details: Array<ExamQuestionDetailAnswerInput>;
  partId: Scalars['ID']['input'];
};

export type FeatureDefaultFilter = {
  appType?: InputMaybe<Array<AppTypeMobile>>;
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<FeatureDefaultFilter>>>;
};

export type FeatureSetFilter = {
  hasCustomDomainWith?: InputMaybe<CustomDomainFilter>;
  hasFeatureDefaultWith?: InputMaybe<FeatureDefaultFilter>;
  hasSchoolWith?: InputMaybe<SchoolFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<FeatureSetFilter>>>;
};

export type FeaturedPlaylistCheckPointFilter = {
  hasCheckPointWith?: InputMaybe<CheckPointFilter>;
  hasFeaturedPlaylistWith?: InputMaybe<FeaturedPlaylistFilter>;
};

export type FeaturedPlaylistFilter = {
  and?: InputMaybe<Array<FeaturedPlaylistFilter>>;
  hasFeaturedPlaylistCheckPointsWith?: InputMaybe<FeaturedPlaylistCheckPointFilter>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  not?: InputMaybe<FeaturedPlaylistFilter>;
  or?: InputMaybe<Array<FeaturedPlaylistFilter>>;
  publishMode?: InputMaybe<Array<FeaturedPlaylistPublishMode>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  titleEnQ?: InputMaybe<Array<Scalars['String']['input']>>;
  titleQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum FeaturedPlaylistPublishMode {
  Global = 'GLOBAL',
  Private = 'PRIVATE'
}

export type FirmwareReleaseFilter = {
  and?: InputMaybe<Array<FirmwareReleaseFilter>>;
  /** Exact board type, any of, e.g. "xingzhi-cube-1.54tft-wifi". */
  deviceType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Case-insensitive substring search on board type, matches any of. */
  deviceTypeQ?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<FirmwareReleaseFilter>>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exact match, any of. */
  version?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Case-insensitive substring search, matches any of. */
  versionQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FloatRange = {
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export enum FlyerPackageName {
  CambridgeFlyers = 'CAMBRIDGE_FLYERS',
  CambridgeKet = 'CAMBRIDGE_KET',
  CambridgeMovers = 'CAMBRIDGE_MOVERS',
  CambridgePet = 'CAMBRIDGE_PET',
  CambridgeStarters = 'CAMBRIDGE_STARTERS',
  GlobalSuccessSetJunior = 'GLOBAL_SUCCESS_SET_JUNIOR',
  GlobalSuccessSetPrimary = 'GLOBAL_SUCCESS_SET_PRIMARY',
  Ielts = 'IELTS',
  Kids = 'KIDS',
  Max = 'MAX',
  Teens = 'TEENS',
  ToeflJunior = 'TOEFL_JUNIOR',
  ToeflPrimary = 'TOEFL_PRIMARY'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GrammaticalRangeAndAccuracyBreakdownInput = {
  accuracy?: InputMaybe<StandardFeedbackInput>;
  punctuationControl?: InputMaybe<StandardFeedbackInput>;
  rangeAndFlexibility?: InputMaybe<StandardFeedbackInput>;
  sentenceSuggestion?: InputMaybe<Array<SentenceSuggestionInput>>;
};

export type IeltsBand = {
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};

export type Identifier = {
  Email?: InputMaybe<Scalars['String']['input']>;
  PhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum IdentifierType {
  Email = 'EMAIL',
  PhoneNumber = 'PHONE_NUMBER',
  UserName = 'USER_NAME'
}

export type IeltsCheckPointCreateInput = {
  attemptsAllowed?: InputMaybe<Scalars['Int']['input']>;
  cpType?: InputMaybe<CheckPointType>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  diamond?: InputMaybe<Scalars['Int']['input']>;
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  ieltsBand?: InputMaybe<Scalars['Float']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isBoss?: InputMaybe<Scalars['Boolean']['input']>;
  isPractice: Scalars['Boolean']['input'];
  isPremium: Scalars['Boolean']['input'];
  levels?: InputMaybe<Array<CefrLevel>>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  skills: Array<Scalars['String']['input']>;
  teacherDiamond?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
  type?: InputMaybe<Scalars['CheckPointTypeV1']['input']>;
};

export type IeltsCheckPointUpdateInput = {
  attemptsAllowed?: InputMaybe<Scalars['Int']['input']>;
  cpType?: InputMaybe<CheckPointType>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  diamond?: InputMaybe<Scalars['Int']['input']>;
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  ieltsBand?: InputMaybe<Scalars['Float']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isBoss?: InputMaybe<Scalars['Boolean']['input']>;
  isPractice?: InputMaybe<Scalars['Boolean']['input']>;
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  teacherDiamond?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
  type?: InputMaybe<Scalars['CheckPointTypeV1']['input']>;
};

export type IeltsDetailAnswerInput = {
  detailId: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsDetailInput = {
  contentKey: Scalars['String']['input'];
  detailType: IeltsDetailType;
  explainHtml?: InputMaybe<Scalars['String']['input']>;
  explainHtmlEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isExample?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<IeltsDetailOptionInput>>;
};

export type IeltsDetailOptionInput = {
  correctAnswer: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export enum IeltsDetailType {
  GapFill = 'GAP_FILL',
  Option = 'OPTION',
  Select = 'SELECT'
}

export type IeltsListeningEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
  violationCount?: InputMaybe<Scalars['Int']['input']>;
};

export type IeltsListeningPartAddQuestionsInput = {
  partId: Scalars['ID']['input'];
  questionIds: Array<Scalars['ID']['input']>;
};

export type IeltsListeningPartCreateInput = {
  audioId?: InputMaybe<Scalars['String']['input']>;
  audioSubtitle?: InputMaybe<Scalars['String']['input']>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type IeltsListeningPartFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsListeningPartQuestionInput = {
  position: Scalars['Int']['input'];
  questionId: Scalars['ID']['input'];
};

export type IeltsListeningPartUpdateInput = {
  audioId?: InputMaybe<Scalars['String']['input']>;
  audioSubtitle?: InputMaybe<Scalars['String']['input']>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsListeningQuestionCreateInput = {
  contentHtml: Scalars['String']['input'];
  details: Array<IeltsDetailInput>;
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type IeltsListeningQuestionFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsListeningQuestionUpdateInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Array<IeltsDetailInput>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsListeningStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  bookLessonId?: InputMaybe<Scalars['ID']['input']>;
  challengeCode?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  selectPartIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherInvitation?: InputMaybe<TeacherInvitationInput>;
};

export type IeltsListeningSubmitPartAttemptInput = {
  attemptId: Scalars['ID']['input'];
  detailAnswers: Array<IeltsDetailAnswerInput>;
  partId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};

export type IeltsNoteFilter = {
  hasCheckPointWith?: InputMaybe<CheckPointFilter>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  hasVocabWordWith?: InputMaybe<VocabWordFilter>;
  textQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsReadingEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
  violationCount?: InputMaybe<Scalars['Int']['input']>;
};

export type IeltsReadingPartAddQuestionsInput = {
  partId: Scalars['ID']['input'];
  questionIds: Array<Scalars['ID']['input']>;
};

export type IeltsReadingPartCreateInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type IeltsReadingPartFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsReadingPartQuestionInput = {
  position: Scalars['Int']['input'];
  questionId: Scalars['ID']['input'];
};

export type IeltsReadingPartUpdateInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsReadingQuestionCreateInput = {
  contentHtml: Scalars['String']['input'];
  details: Array<IeltsDetailInput>;
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type IeltsReadingQuestionFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsReadingQuestionUpdateInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Array<IeltsDetailInput>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsReadingStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  bookLessonId?: InputMaybe<Scalars['ID']['input']>;
  challengeCode?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  selectPartIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherInvitation?: InputMaybe<TeacherInvitationInput>;
};

export type IeltsReadingSubmitPartAttemptInput = {
  attemptId: Scalars['ID']['input'];
  detailAnswers: Array<IeltsDetailAnswerInput>;
  partId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};

export enum IeltsSkill {
  FUll = 'FUll',
  Listening = 'LISTENING',
  Reading = 'READING',
  Speaking = 'SPEAKING',
  Writing = 'WRITING'
}

export type IeltsSpeakingEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
  violationCount?: InputMaybe<Scalars['Int']['input']>;
};

export type IeltsSpeakingPartCreateInput = {
  defaultShowQuestionContents?: InputMaybe<Scalars['Boolean']['input']>;
  expiredTime: Scalars['Duration']['input'];
  infoId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type IeltsSpeakingPartFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsSpeakingPartInfoCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  introductionAudioId?: InputMaybe<Scalars['ID']['input']>;
  introductionText: Scalars['String']['input'];
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type IeltsSpeakingPartInfoFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsSpeakingPartInfoUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  introductionAudioId?: InputMaybe<Scalars['ID']['input']>;
  introductionText?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsSpeakingPartQuestionInput = {
  position: Scalars['Int']['input'];
  questionId: Scalars['ID']['input'];
};

export type IeltsSpeakingPartUpdateInput = {
  defaultShowQuestionContents?: InputMaybe<Scalars['Boolean']['input']>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  id: Scalars['ID']['input'];
  infoId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type IeltsSpeakingQuestionCreateInput = {
  audioId: Scalars['ID']['input'];
  contentHtml: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sampleAnswerAudioId?: InputMaybe<Scalars['ID']['input']>;
  sampleAnswerHtml: Scalars['String']['input'];
  timeToSpeak: Scalars['Duration']['input'];
  timeToThink?: InputMaybe<Scalars['Duration']['input']>;
  title: Scalars['String']['input'];
};

export type IeltsSpeakingQuestionFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsSpeakingQuestionUpdateInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sampleAnswerAudioId?: InputMaybe<Scalars['ID']['input']>;
  sampleAnswerHtml?: InputMaybe<Scalars['String']['input']>;
  timeToSpeak?: InputMaybe<Scalars['Duration']['input']>;
  timeToThink?: InputMaybe<Scalars['Duration']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsSpeakingStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  bookLessonId?: InputMaybe<Scalars['ID']['input']>;
  challengeCode?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  requestAIAzure?: InputMaybe<Scalars['Boolean']['input']>;
  requestAIAzureDiamond?: InputMaybe<Scalars['Boolean']['input']>;
  requestAIReview?: InputMaybe<Scalars['Boolean']['input']>;
  requestReview?: InputMaybe<Scalars['Boolean']['input']>;
  teacherInvitation?: InputMaybe<TeacherInvitationInput>;
};

export type IeltsSpeakingSubmitPartAttemptInput = {
  attemptId: Scalars['ID']['input'];
  partId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  recordId: Scalars['ID']['input'];
};

export type IeltsSpeakingSubmitQuestionAttemptInput = {
  attemptId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  partId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  recordId: Scalars['ID']['input'];
};

export type IeltsViewerNoteCreateInput = {
  checkPointId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  listeningPartId?: InputMaybe<Scalars['String']['input']>;
  listeningQuestionId?: InputMaybe<Scalars['String']['input']>;
  readingPartId?: InputMaybe<Scalars['String']['input']>;
  readingQuestionId?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type IeltsViewerNoteUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type IeltsWritingEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
  violationCount?: InputMaybe<Scalars['Int']['input']>;
};

export type IeltsWritingPartCreateInput = {
  aiPrompt?: InputMaybe<WritingAiPromptInput>;
  audioId?: InputMaybe<Scalars['String']['input']>;
  audioSubtitle?: InputMaybe<Scalars['String']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  learnFromSampleHtml?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  sampleAnswerHtml?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type IeltsWritingPartFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsWritingPartQuestionInput = {
  position: Scalars['Int']['input'];
  questionId: Scalars['ID']['input'];
};

export type IeltsWritingPartUpdateInput = {
  aiPrompt?: InputMaybe<WritingAiPromptInput>;
  audioId?: InputMaybe<Scalars['String']['input']>;
  audioSubtitle?: InputMaybe<Scalars['String']['input']>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  expiredTime?: InputMaybe<Scalars['Duration']['input']>;
  id: Scalars['ID']['input'];
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  learnFromSampleHtml?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  sampleAnswerHtml?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsWritingQuestionCreateInput = {
  contentHtml: Scalars['String']['input'];
  details: Array<IeltsDetailInput>;
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type IeltsWritingQuestionFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IeltsWritingQuestionUpdateInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Array<IeltsDetailInput>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IeltsWritingScoringPartInput = {
  markingCriteria?: InputMaybe<Array<WritingMarkingCriteriaInput>>;
  partId: Scalars['ID']['input'];
  teacherCommentsAnswers?: InputMaybe<Array<TeacherCommentDetailInput>>;
  teacherFixedAnswer?: InputMaybe<Scalars['JSON']['input']>;
  teacherWordCount?: InputMaybe<Scalars['Int']['input']>;
};

export type IeltsWritingStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  bookLessonId?: InputMaybe<Scalars['ID']['input']>;
  challengeCode?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  requestAIReview?: InputMaybe<Scalars['Boolean']['input']>;
  requestReview?: InputMaybe<Scalars['Boolean']['input']>;
  teacherInvitation?: InputMaybe<TeacherInvitationInput>;
};

export type IeltsWritingSubmitPartAttemptInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  attemptId: Scalars['ID']['input'];
  partId: Scalars['ID']['input'];
  questionAnswer?: InputMaybe<IeltsWritingSubmitQuestionAnswerInput>;
};

export type IeltsWritingSubmitQuestionAnswerInput = {
  detailAnswers: Array<IeltsDetailAnswerInput>;
  questionId: Scalars['ID']['input'];
};

export type IntRange = {
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type JoinClassCodeFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  usedAt?: InputMaybe<DateTimeRange>;
};

export type JoinClassCodeOrder = {
  key?: InputMaybe<JoinClassCodeOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum JoinClassCodeOrderKey {
  UsedAt = 'USED_AT'
}

export enum KetPetGradeCert {
  A = 'A',
  B = 'B',
  C = 'C'
}

export type KetPetWritingAssessmentInput = {
  criteria?: InputMaybe<Array<CriterionInput>>;
  detailedLanguageFeedback?: InputMaybe<Array<LanguageFeedbackInput>>;
  overview?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
};

export type LanguageFeedbackInput = {
  correction?: InputMaybe<Scalars['String']['input']>;
  errorType?: InputMaybe<Scalars['String']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  studentUse?: InputMaybe<Scalars['String']['input']>;
};

export enum LearnerBingoStudyLevelState {
  Active = 'ACTIVE',
  Locked = 'LOCKED',
  Passed = 'PASSED'
}

export type LearnerChallengeRankFilter = {
  displayNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  learnerProfileId?: InputMaybe<Array<Scalars['ID']['input']>>;
  schoolId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type LearnerChallengeRankOrder = {
  key?: InputMaybe<LearnerChallengeRankOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LearnerChallengeRankOrderKey {
  Rank = 'RANK'
}

export enum LearnerDuolingoLevelState {
  Active = 'ACTIVE',
  Locked = 'LOCKED',
  Passed = 'PASSED'
}

export type LearnerMistakeWordFilter = {
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  hasWordWith?: InputMaybe<VocabWordFilter>;
  noteType?: InputMaybe<Array<LearnerMistakeWordNoteType>>;
  status?: InputMaybe<Array<StatusLearnerMistakeWord>>;
};

export enum LearnerMistakeWordNoteType {
  Mistake = 'MISTAKE',
  Note = 'NOTE'
}

export type LearnerMistakeWordOrder = {
  key?: InputMaybe<LearnerMistakeWordOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LearnerMistakeWordOrderKey {
  Word = 'WORD'
}

export type LearnerProfileFilter = {
  aboutToExpired?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<LearnerProfileFilter>>;
  displayNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  hasClassStudentsWith?: InputMaybe<ClassStudentFilter>;
  hasSchoolWith?: InputMaybe<SchoolFilter>;
  hasUserAttemptsWith?: InputMaybe<UserAttemptFilter>;
  hasUserWith?: InputMaybe<UserFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<LearnerProfileFilter>;
  or?: InputMaybe<Array<LearnerProfileFilter>>;
  q?: InputMaybe<Array<Scalars['String']['input']>>;
  studentNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  subscriptionStatus?: InputMaybe<SubscriptionStatusFilter>;
};

export type LearnerProfileOrder = {
  key?: InputMaybe<LearnerProfileOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LearnerProfileOrderKey {
  DateOfBirth = 'DATE_OF_BIRTH',
  DisplayName = 'DISPLAY_NAME',
  Id = 'ID',
  PhoneNumber = 'PHONE_NUMBER',
  SubscriptionExpiresAt = 'SUBSCRIPTION_EXPIRES_AT',
  Username = 'USERNAME',
  UserCreatedAt = 'USER_CREATED_AT'
}

export type LearnerStatsUpdateFromAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type LearnerTestLevelRankFilter = {
  displayNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  learnerProfileId?: InputMaybe<Array<Scalars['ID']['input']>>;
  provinceId?: InputMaybe<Array<Scalars['ID']['input']>>;
  schoolId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type LearnerXpFilter = {
  date?: InputMaybe<DateTimeRange>;
};

export type LearningOutcomeSubjectCreateInput = {
  title: Scalars['String']['input'];
  titleEn: Scalars['String']['input'];
};

export type LearningOutcomeSubjectFilter = {
  and?: InputMaybe<Array<LearningOutcomeSubjectFilter>>;
  hasBingoSubjectWith?: InputMaybe<BingoSubjectFilter>;
  or?: InputMaybe<Array<LearningOutcomeSubjectFilter>>;
  titleEnQ?: InputMaybe<Array<Scalars['String']['input']>>;
  titleQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LearningOutcomeSubjectUpdateInput = {
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
};

export type LexicalResourceBreakdownInput = {
  appropriacyAndCollocation?: InputMaybe<StandardFeedbackInput>;
  rangeFlexibilityPrecision?: InputMaybe<StandardFeedbackInput>;
  sentenceSuggestion?: InputMaybe<Array<SentenceSuggestionInput>>;
  spellingAndWordFormation?: InputMaybe<StandardFeedbackInput>;
};

export type MenuNotificationFilter = {
  menuCodeQ?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<MenuNotificationType>>;
};

export enum MenuNotificationLayout {
  L1 = 'L1',
  L2 = 'L2'
}

export enum MenuNotificationType {
  Guideline = 'GUIDELINE',
  Tutorial = 'TUTORIAL'
}

export enum MetaDataAudioKind {
  Record = 'record'
}

export enum MetaDataAudioPath {
  Audio = 'audio',
  Avatar = 'avatar',
  Image = 'image'
}

export type MetaInfoInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type MoveInput = {
  id: Scalars['ID']['input'];
  newPosition: Scalars['Int']['input'];
};

export type NotificationEventContentInput = {
  action: Scalars['String']['input'];
  bodyTemplate: NotificationEventTemplateInput;
  link?: InputMaybe<Scalars['String']['input']>;
  linkEn?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  titleTemplate: NotificationEventTemplateInput;
};

export type NotificationEventCreateInput = {
  appType: Scalars['String']['input'];
  eventNParam?: InputMaybe<Scalars['Int']['input']>;
  eventType: Scalars['String']['input'];
  notifyAfter: Scalars['Int']['input'];
  notifyCondition?: InputMaybe<Scalars['String']['input']>;
  notifyContent?: InputMaybe<NotificationEventContentInput>;
  notifyData?: InputMaybe<NotificationEventDataInput>;
};

export type NotificationEventDataInput = {
  voucherCode?: InputMaybe<Scalars['String']['input']>;
  voucherCondition?: InputMaybe<Scalars['String']['input']>;
  voucherEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  voucherName?: InputMaybe<Scalars['String']['input']>;
  voucherStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationEventDeleteInput = {
  id: Scalars['ID']['input'];
};

export type NotificationEventOrder = {
  key?: InputMaybe<NotificationEventOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NotificationEventOrderKey {
  Id = 'ID'
}

export type NotificationEventSendInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  body: Scalars['String']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};

export type NotificationEventTemplateInput = {
  text: Scalars['String']['input'];
  textEn: Scalars['String']['input'];
};

export type NotificationEventUpdateInput = {
  eventNParam?: InputMaybe<Scalars['Int']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notifyAfter?: InputMaybe<Scalars['Int']['input']>;
  notifyCondition?: InputMaybe<Scalars['String']['input']>;
  notifyContent?: InputMaybe<NotificationEventContentInput>;
  notifyData?: InputMaybe<NotificationEventDataInput>;
};

export type NotificationFilter = {
  and?: InputMaybe<Array<NotificationFilter>>;
  floatSeen?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<NotificationFilter>>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Array<NotificationSource>>;
  type?: InputMaybe<Array<NotificationType>>;
  typeNotification?: InputMaybe<Array<NotificationTypeNotification>>;
};

export type NotificationMetaInput = {
  attemptID?: InputMaybe<Scalars['ID']['input']>;
  challengeCode?: InputMaybe<Scalars['String']['input']>;
  linkExam?: InputMaybe<Scalars['String']['input']>;
  schoolInvitation?: InputMaybe<NotificationSchoolInvitationInput>;
};

export type NotificationSchoolInvitationInput = {
  code: Scalars['String']['input'];
  status: InvitationStatus;
};

export enum NotificationSource {
  Flyer = 'FLYER',
  Partner = 'PARTNER'
}

export enum NotificationStatusLeaveClass {
  Accept = 'ACCEPT',
  Reject = 'REJECT'
}

export enum NotificationType {
  ChallengeInvite = 'CHALLENGE_INVITE',
  CheckPointReviewRequestAccept = 'CHECK_POINT_REVIEW_REQUEST_ACCEPT',
  CheckPointReviewRequestReject = 'CHECK_POINT_REVIEW_REQUEST_REJECT',
  ClassOnlineRemind = 'CLASS_ONLINE_REMIND',
  ClassRemindLateLesson = 'CLASS_REMIND_LATE_LESSON',
  ClassRemindLesson = 'CLASS_REMIND_LESSON',
  CustomDomainApproved = 'CUSTOM_DOMAIN_APPROVED',
  CustomDomainRejected = 'CUSTOM_DOMAIN_REJECTED',
  JoinSchoolRequest = 'JOIN_SCHOOL_REQUEST',
  LeaveClass = 'LEAVE_CLASS',
  LookBack = 'LOOK_BACK',
  NewFeature = 'NEW_FEATURE',
  NewMission = 'NEW_MISSION',
  NewScorePractice = 'NEW_SCORE_PRACTICE',
  NewScoreSpeaking = 'NEW_SCORE_SPEAKING',
  NewScoreWriting = 'NEW_SCORE_WRITING',
  ParentWeeklyReport = 'PARENT_WEEKLY_REPORT',
  ProgramReviewRequestAccept = 'PROGRAM_REVIEW_REQUEST_ACCEPT',
  ProgramReviewRequestReject = 'PROGRAM_REVIEW_REQUEST_REJECT',
  ReferredUser = 'REFERRED_USER',
  SchoolInvite = 'SCHOOL_INVITE',
  SubmitAttempt = 'SUBMIT_ATTEMPT',
  TeacherInvite = 'TEACHER_INVITE',
  UpdatePhoneNumber = 'UPDATE_PHONE_NUMBER',
  UpdateSchool = 'UPDATE_SCHOOL',
  WeeklyStudyTimeRemaining = 'WEEKLY_STUDY_TIME_REMAINING',
  WisdomStoneGranted = 'WISDOM_STONE_GRANTED',
  WisdomStoneRevoked = 'WISDOM_STONE_REVOKED',
  WisdomStoneStoreApproved = 'WISDOM_STONE_STORE_APPROVED',
  WisdomStoneStoreRejected = 'WISDOM_STONE_STORE_REJECTED',
  WisdomStoneStoreRequested = 'WISDOM_STONE_STORE_REQUESTED'
}

export enum NotificationTypeNotification {
  Global = 'GLOBAL',
  GlobalParent = 'GLOBAL_PARENT',
  GlobalPartner = 'GLOBAL_PARTNER',
  Ielts = 'IELTS',
  Parent = 'PARENT',
  Partner = 'PARTNER',
  User = 'USER'
}

/** OrderCodeCodeType is enum for the field codeType */
export enum OrderCodeCodeType {
  Agent = 'agent',
  Giveaway = 'giveaway',
  GiveawayAgent = 'giveaway_agent',
  Iservice = 'iservice',
  MaxTrial = 'max_trial',
  Partner = 'partner',
  Reissue = 'reissue',
  Retail = 'retail',
  RetailManual = 'retail_manual',
  TeacherCode = 'teacher_code',
  Vnpay = 'vnpay'
}

export type OrderCodeFilter = {
  codeType?: InputMaybe<Array<OrderCodeCodeType>>;
  descriptionQ?: InputMaybe<Array<Scalars['String']['input']>>;
  planDay?: InputMaybe<DurationRange>;
  status?: InputMaybe<Array<OrderCodeStatus>>;
};

/** OrderCodeStatus is enum for the field status */
export enum OrderCodeStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum OrderCodeType {
  Code = 'CODE',
  TeacherDiamond = 'TEACHER_DIAMOND'
}

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OverallScoreInput = {
  coherenceAndCohesion?: InputMaybe<OverallSummaryInput>;
  grammaticalRangeAndAccuracy?: InputMaybe<OverallSummaryInput>;
  lexicalResource?: InputMaybe<OverallSummaryInput>;
  overallBand?: InputMaybe<Scalars['Float']['input']>;
  taskPerformance?: InputMaybe<OverallSummaryInput>;
};

export type OverallSummaryInput = {
  score?: InputMaybe<Scalars['Float']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summaryVi?: InputMaybe<Scalars['String']['input']>;
};

export type ParentAssignTestCreateInput = {
  allowLateSubmit?: InputMaybe<Scalars['Boolean']['input']>;
  bingoSubjectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkPointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  examMode?: InputMaybe<Scalars['Boolean']['input']>;
  externalLinks?: InputMaybe<Array<Scalars['String']['input']>>;
  isHiddenAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  learnerProfileIds: Array<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
};

export type ParentAssignTestDeleteInput = {
  assignTestID: Scalars['ID']['input'];
};

export type ParentAssignTestUpdateInput = {
  allowLateSubmit?: InputMaybe<Scalars['Boolean']['input']>;
  assignTestID: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  examMode?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ParentViewerSeenNotificationInput = {
  all?: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum PartnerAiSpeakingRecordFilterMode {
  All = 'ALL',
  Record = 'RECORD',
  Video = 'VIDEO'
}

export type PartnerAccuracyRankingInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerActivitiesFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  hasClassWith?: InputMaybe<ClassFilter>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  hasSchoolWith?: InputMaybe<SchoolFilter>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  hasUserAttemptWith?: InputMaybe<UserAttemptFilter>;
};

export enum PartnerActivitiesType {
  StudentSubmitAttempt = 'STUDENT_SUBMIT_ATTEMPT'
}

export type PartnerAssignTeachersToClassesInput = {
  classIds: Array<Scalars['ID']['input']>;
  teacherProfileIds: Array<Scalars['ID']['input']>;
};

export type PartnerAssignTestCreateInput = {
  allowLateSubmit?: InputMaybe<Scalars['Boolean']['input']>;
  bingoSubjectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkPointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  examMode?: InputMaybe<Scalars['Boolean']['input']>;
  externalLinks?: InputMaybe<Array<Scalars['String']['input']>>;
  isHiddenAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  profileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  testLevelId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleCalendarEvent?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
  typeExam?: InputMaybe<TypeExamAssignTest>;
  typeInit?: InputMaybe<TypeInitAssignTest>;
};

export type PartnerAssignTestSubmitUpdateInput = {
  userAttemptID: Scalars['ID']['input'];
};

export type PartnerAssignTestUpdateInput = {
  allowLateSubmit?: InputMaybe<Scalars['Boolean']['input']>;
  assignTestID: Scalars['ID']['input'];
  classIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  examMode?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  profileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  typeInit?: InputMaybe<TypeInitAssignTest>;
};

export enum PartnerBillingHistoriesAction {
  CreateAccount = 'CREATE_ACCOUNT',
  Deposit = 'DEPOSIT',
  ExtendAccount = 'EXTEND_ACCOUNT',
  RollBackAccount = 'ROLL_BACK_ACCOUNT',
  ScoreSpeakingAi = 'SCORE_SPEAKING_AI',
  ScoreWritingAi = 'SCORE_WRITING_AI',
  TransferIn = 'TRANSFER_IN',
  TransferOut = 'TRANSFER_OUT'
}

export type PartnerBillingHistoriesFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
};

export type PartnerBookCreateInput = {
  coverImageId: Scalars['String']['input'];
  levels: Array<CefrLevel>;
  name?: InputMaybe<Scalars['String']['input']>;
  noUnits?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  schoolIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerBookDuplicateInput = {
  bookId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type PartnerBookLessonCreateInput = {
  contentHtml: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  unitId: Scalars['ID']['input'];
};

export type PartnerBookLessonUpdateInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerBookUnitCreateInput = {
  bookId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  lessonType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  topic: Scalars['String']['input'];
};

export type PartnerBookUnitUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lessonType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerBookUpdateInput = {
  community?: InputMaybe<Scalars['Boolean']['input']>;
  coverImageId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  levels?: InputMaybe<Array<CefrLevel>>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  schoolIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum PartnerBooksFilterMode {
  All = 'ALL',
  Community = 'COMMUNITY',
  Flyer = 'FLYER',
  School = 'SCHOOL',
  Teacher = 'TEACHER'
}

export type PartnerClassRankingInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerClassScheduleCreateInput = {
  classId: Scalars['ID']['input'];
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  programBookId?: InputMaybe<Scalars['ID']['input']>;
  programBookStartFromLessonId?: InputMaybe<Scalars['ID']['input']>;
  programStudyPathId?: InputMaybe<Scalars['ID']['input']>;
  programStudyStartFromLevelId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeLocal?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PartnerClassScheduleUpdateInput = {
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  programBookStartFromLessonId?: InputMaybe<Scalars['ID']['input']>;
  programStudyStartFromLevelId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeLocal?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PartnerClassUpdateInput = {
  classLevelId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardStep?: InputMaybe<Scalars['Int']['input']>;
  pin?: InputMaybe<Scalars['Boolean']['input']>;
  targetNotification?: InputMaybe<Scalars['Boolean']['input']>;
  weeklyTimeTarget?: InputMaybe<Scalars['Duration']['input']>;
};

export type PartnerCompletedTestChartInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  skills?: InputMaybe<Array<InputMaybe<EnglishSkillV1>>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  studentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  testLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<TypeAttempt>;
  typeAttempts?: InputMaybe<Array<TypeAttempt>>;
};

export type PartnerDetailCompletedTestInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  studentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  testLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<TypeAttempt>;
  typeAttempts?: InputMaybe<Array<TypeAttempt>>;
};

export type PartnerDetailStudyTimeInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  studentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  testLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<TypeAttempt>;
  typeAttempts?: InputMaybe<Array<TypeAttempt>>;
};

export type PartnerIeltsCheckPointCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  ieltsSkill: IeltsSkill;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
};

export type PartnerIeltsCheckPointRemoveInput = {
  id: Scalars['ID']['input'];
};

export type PartnerIeltsCheckPointUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
};

export type PartnerIeltsPartAddQuestionsInput = {
  listening?: InputMaybe<IeltsListeningPartAddQuestionsInput>;
  reading?: InputMaybe<IeltsReadingPartAddQuestionsInput>;
};

export type PartnerIeltsPartCreateInput = {
  listening?: InputMaybe<IeltsListeningPartCreateInput>;
  reading?: InputMaybe<IeltsReadingPartCreateInput>;
  writing?: InputMaybe<IeltsWritingPartCreateInput>;
};

export type PartnerIeltsPartRemoveInput = {
  ieltsListeningPartId?: InputMaybe<Scalars['ID']['input']>;
  ieltsReadingPartId?: InputMaybe<Scalars['ID']['input']>;
  ieltsWritingPartId?: InputMaybe<Scalars['ID']['input']>;
};

export type PartnerIeltsPartUpdateInput = {
  listening?: InputMaybe<IeltsListeningPartUpdateInput>;
  reading?: InputMaybe<IeltsReadingPartUpdateInput>;
  writing?: InputMaybe<IeltsWritingPartUpdateInput>;
};

export type PartnerIeltsQuestionCreateInput = {
  listening?: InputMaybe<IeltsListeningQuestionCreateInput>;
  reading?: InputMaybe<IeltsReadingQuestionCreateInput>;
};

export type PartnerIeltsQuestionRemoveInput = {
  ieltsListeningQuestionId?: InputMaybe<Scalars['ID']['input']>;
  ieltsReadingQuestionId?: InputMaybe<Scalars['ID']['input']>;
};

export type PartnerIeltsQuestionUpdateInput = {
  listening?: InputMaybe<IeltsListeningQuestionUpdateInput>;
  reading?: InputMaybe<IeltsReadingQuestionUpdateInput>;
};

export type PartnerIeltsSpeakingAttemptTeacherScoreInput = {
  id: Scalars['ID']['input'];
  teacherComment?: InputMaybe<Scalars['String']['input']>;
  teacherCommentAudioId?: InputMaybe<Scalars['ID']['input']>;
  teacherGrade?: InputMaybe<Scalars['Float']['input']>;
  teacherSeenRequest?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartnerIeltsSpeakingQuestionAttemptTeacherScoreInput = {
  id: Scalars['ID']['input'];
  teacherComment?: InputMaybe<Scalars['JSON']['input']>;
  teacherCommentAudioId?: InputMaybe<Scalars['ID']['input']>;
  teacherCommentDetails?: InputMaybe<Array<TeacherCommentDetailInput>>;
  teacherCommentHtml?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerInfoAssignTestInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  levels?: InputMaybe<Array<Scalars['String']['input']>>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PartnerListAssignTestInput = {
  endDate?: InputMaybe<DateTimeRange>;
  levels?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  startDate?: InputMaybe<DateTimeRange>;
  statuses?: InputMaybe<Array<PartnerListAssignTestStatusEnum>>;
  teacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum PartnerListAssignTestStatusEnum {
  Done = 'DONE',
  NoneStarted = 'NONE_STARTED',
  Progress = 'PROGRESS'
}

export type PartnerOverviewInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  skills?: InputMaybe<Array<InputMaybe<EnglishSkillV1>>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  studentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  testLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<TypeAttempt>;
  typeAttempts?: InputMaybe<Array<TypeAttempt>>;
};

export type PartnerPackageFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerPracticeCheckPointCreateInput = {
  imageId?: InputMaybe<Scalars['ID']['input']>;
  levels: Array<CefrLevel>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  skills: Array<EnglishSkillV1>;
  themeId?: InputMaybe<Scalars['ID']['input']>;
  time: Scalars['Duration']['input'];
};

export type PartnerPracticeCheckPointGenInput = {
  audioResponsePartId?: InputMaybe<Scalars['ID']['input']>;
  checkPointId?: InputMaybe<Scalars['ID']['input']>;
  extractQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  fromContentHtml?: InputMaybe<Scalars['String']['input']>;
  fromFileId?: InputMaybe<Scalars['ID']['input']>;
  genAudioResponsePart?: InputMaybe<Scalars['Boolean']['input']>;
  genPartType?: InputMaybe<PartnerPracticeCheckPointGenPartType>;
  genPassagePart?: InputMaybe<Scalars['Boolean']['input']>;
  level: CefrLevel;
  listImageRemove?: InputMaybe<Array<Scalars['String']['input']>>;
  noParts: Scalars['Int']['input'];
  parentPartId?: InputMaybe<Scalars['ID']['input']>;
  partTypes?: InputMaybe<Array<PracticePartType>>;
  passagePartId?: InputMaybe<Scalars['ID']['input']>;
  prompt: PartnerPracticeCheckPointGenPromptInput;
};

export enum PartnerPracticeCheckPointGenPartType {
  AudioResponse = 'AUDIO_RESPONSE',
  Flashcard = 'FLASHCARD',
  Passage = 'PASSAGE'
}

export type PartnerPracticeCheckPointGenPromptInput = {
  fileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerPracticeCheckPointUpdateInput = {
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  themeId?: InputMaybe<Scalars['ID']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
};

export type PartnerPracticeGenEvalCriteriaInput = {
  isPartialGrading: Scalars['Boolean']['input'];
  level: CefrLevel;
  maxScore: Scalars['Float']['input'];
  question: Scalars['String']['input'];
};

export type PartnerPracticePartCreateInput = {
  answerExplanationHtml?: InputMaybe<Scalars['String']['input']>;
  answerExplanationHtmlEn?: InputMaybe<Scalars['String']['input']>;
  audioResponsePartId?: InputMaybe<Scalars['ID']['input']>;
  body: PracticePartBodyInput;
  checkPointId: Scalars['ID']['input'];
  layout?: InputMaybe<PracticePartLayout>;
  parentPartId?: InputMaybe<Scalars['ID']['input']>;
  passagePartId?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
  score: Scalars['Float']['input'];
  time?: InputMaybe<Scalars['Duration']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: PracticePartType;
};

export type PartnerPracticePartGenOptionsInput = {
  multipleCorrectAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  numOptions: Scalars['Int']['input'];
  questionHtml: Scalars['String']['input'];
};

export type PartnerPracticePartUpdateInput = {
  answerExplanationHtml?: InputMaybe<Scalars['String']['input']>;
  answerExplanationHtmlEn?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<PracticePartBodyInput>;
  id: Scalars['ID']['input'];
  layout?: InputMaybe<PracticePartLayout>;
  position?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  time?: InputMaybe<Scalars['Duration']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PracticePartType>;
};

export type PartnerPracticeTryEvalResponseInput = {
  evaluationCriteria: PracticePartEvaluationCriteriaInput;
  maxScore: Scalars['Float']['input'];
  question: Scalars['String']['input'];
  response: Scalars['String']['input'];
};

export type PartnerRollupAssignTestFilter = {
  endDate?: InputMaybe<DateRangeInput>;
  levels?: InputMaybe<Array<CefrLevel>>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  startDate?: InputMaybe<DateRangeInput>;
  statuses?: InputMaybe<Array<StatusAssignTest>>;
};

export type PartnerRollupAssignTestOrder = {
  direction: OrderDirection;
  key: PartnerRollupAssignTestOrderKey;
};

export enum PartnerRollupAssignTestOrderKey {
  Accuracy = 'ACCURACY',
  Assignees = 'ASSIGNEES',
  BingoSubjectTitleEn = 'BINGO_SUBJECT_TITLE_EN',
  BingoSubjectTitleVi = 'BINGO_SUBJECT_TITLE_VI',
  CheckPointName = 'CHECK_POINT_NAME',
  CheckPointNameEn = 'CHECK_POINT_NAME_EN',
  EndDate = 'END_DATE',
  Name = 'NAME',
  NameEn = 'NAME_EN',
  Progress = 'PROGRESS',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  TeacherDisplayName = 'TEACHER_DISPLAY_NAME',
  TestLevelName = 'TEST_LEVEL_NAME'
}

export type PartnerRollupAssignTestProfileFilter = {
  highestScore?: InputMaybe<FloatRange>;
  q?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<StudentAssignTestStatus>>;
};

export type PartnerRollupAssignTestProfileOrder = {
  direction: OrderDirection;
  key: PartnerRollupAssignTestProfileOrderKey;
};

export enum PartnerRollupAssignTestProfileOrderKey {
  AvgAccuracy = 'AVG_ACCURACY',
  AvgTime = 'AVG_TIME',
  CreatedAt = 'CREATED_AT',
  FirstAttemptAccuracy = 'FIRST_ATTEMPT_ACCURACY',
  FirstAttemptScore = 'FIRST_ATTEMPT_SCORE',
  HighestScore = 'HIGHEST_SCORE',
  LastSubmittedAt = 'LAST_SUBMITTED_AT',
  StartedAt = 'STARTED_AT',
  Status = 'STATUS',
  SubmitTime = 'SUBMIT_TIME'
}

export type PartnerRollupClassFilter = {
  classNameQ?: InputMaybe<Scalars['String']['input']>;
  isSample?: InputMaybe<Scalars['Boolean']['input']>;
  studentCompletedAssignTestsRate?: InputMaybe<FloatRange>;
  studyTime?: InputMaybe<DurationRange>;
};

export type PartnerRollupClassOrder = {
  direction: OrderDirection;
  key: PartnerRollupClassOrderKey;
};

export enum PartnerRollupClassOrderKey {
  AvgAccuracy = 'AVG_ACCURACY',
  ClassName = 'CLASS_NAME',
  ClassPin = 'CLASS_PIN',
  CompletedTests = 'COMPLETED_TESTS',
  ConversationTime = 'CONVERSATION_TIME',
  StudentCompletedAssignTestsRate = 'STUDENT_COMPLETED_ASSIGN_TESTS_RATE',
  StudentCount = 'STUDENT_COUNT',
  StudyTime = 'STUDY_TIME',
  TotalAssignTests = 'TOTAL_ASSIGN_TESTS',
  TotalStudentAssignedAssignTests = 'TOTAL_STUDENT_ASSIGNED_ASSIGN_TESTS',
  TotalStudentCompletedAssignTests = 'TOTAL_STUDENT_COMPLETED_ASSIGN_TESTS',
  TotalStudentUncompletedAssignTests = 'TOTAL_STUDENT_UNCOMPLETED_ASSIGN_TESTS'
}

export type PartnerRollupConversationStudentFilter = {
  displayNameQ?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerRollupConversationStudentOrder = {
  direction: OrderDirection;
  key: PartnerRollupConversationStudentOrderKey;
};

export enum PartnerRollupConversationStudentOrderKey {
  DisplayName = 'DISPLAY_NAME',
  TotalCalls = 'TOTAL_CALLS',
  TotalCallTime = 'TOTAL_CALL_TIME'
}

export type PartnerRollupNewStudentFilter = {
  displayNameQ?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  joinedDate?: InputMaybe<DateTimeRange>;
  q?: InputMaybe<Scalars['String']['input']>;
  subscriptionStatus?: InputMaybe<SubscriptionStatus>;
};

export type PartnerRollupNewStudentOrder = {
  direction: OrderDirection;
  key: PartnerRollupNewStudentOrderKey;
};

export enum PartnerRollupNewStudentOrderKey {
  DisplayName = 'DISPLAY_NAME',
  Email = 'EMAIL',
  LastAttemptListeningScore = 'LAST_ATTEMPT_LISTENING_SCORE',
  LastAttemptReadingWritingScore = 'LAST_ATTEMPT_READING_WRITING_SCORE',
  LastAttemptScore = 'LAST_ATTEMPT_SCORE',
  LastAttemptSpeakingScore = 'LAST_ATTEMPT_SPEAKING_SCORE',
  LastSubmittedAttempt = 'LAST_SUBMITTED_ATTEMPT',
  PhoneNumber = 'PHONE_NUMBER',
  SubscriptionExpiresAt = 'SUBSCRIPTION_EXPIRES_AT'
}

export type PartnerRollupStudentAssignTestFilter = {
  endDate?: InputMaybe<DateRangeInput>;
  levels?: InputMaybe<Array<CefrLevel>>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  startDate?: InputMaybe<DateRangeInput>;
  statuses?: InputMaybe<Array<StudentAssignTestStatus>>;
};

export type PartnerRollupStudentAssignTestOrder = {
  direction: OrderDirection;
  key: PartnerRollupStudentAssignTestOrderKey;
};

export enum PartnerRollupStudentAssignTestOrderKey {
  BingoSubjectTitleEn = 'BINGO_SUBJECT_TITLE_EN',
  BingoSubjectTitleVi = 'BINGO_SUBJECT_TITLE_VI',
  CheckPointName = 'CHECK_POINT_NAME',
  CheckPointNameEn = 'CHECK_POINT_NAME_EN',
  EndDate = 'END_DATE',
  HighestScore = 'HIGHEST_SCORE',
  Name = 'NAME',
  NameEn = 'NAME_EN',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  SubmitTime = 'SUBMIT_TIME',
  TeacherDisplayName = 'TEACHER_DISPLAY_NAME',
  TestLevelName = 'TEST_LEVEL_NAME'
}

export type PartnerRollupStudentFilter = {
  aboutToExpired?: InputMaybe<Scalars['Boolean']['input']>;
  avgAssignTestAccuracy?: InputMaybe<FloatRange>;
  avgTestAccuracy?: InputMaybe<FloatRange>;
  avgTestScore?: InputMaybe<FloatRange>;
  displayNameQ?: InputMaybe<Scalars['String']['input']>;
  hasSelfStudy?: InputMaybe<Scalars['Boolean']['input']>;
  hasUncompletedAssignTests?: InputMaybe<Scalars['Boolean']['input']>;
  isSubscribing?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  studentNameQ?: InputMaybe<Scalars['String']['input']>;
  totalStudyTime?: InputMaybe<DurationRange>;
  uncompletedAssignTestsRate?: InputMaybe<FloatRange>;
};

export type PartnerRollupStudentOrder = {
  direction: OrderDirection;
  key: PartnerRollupStudentOrderKey;
};

export enum PartnerRollupStudentOrderKey {
  AvgAssignTestAccuracy = 'AVG_ASSIGN_TEST_ACCURACY',
  AvgTestAccuracy = 'AVG_TEST_ACCURACY',
  AvgTestScore = 'AVG_TEST_SCORE',
  ClassName = 'CLASS_NAME',
  DisplayName = 'DISPLAY_NAME',
  Email = 'EMAIL',
  JoinedDate = 'JOINED_DATE',
  PhoneNumber = 'PHONE_NUMBER',
  SubscriptionExpiresAt = 'SUBSCRIPTION_EXPIRES_AT',
  TotalAssignTests = 'TOTAL_ASSIGN_TESTS',
  TotalBingoTalkTime = 'TOTAL_BINGO_TALK_TIME',
  TotalCompletedAssignTests = 'TOTAL_COMPLETED_ASSIGN_TESTS',
  TotalCompletedTests = 'TOTAL_COMPLETED_TESTS',
  TotalConversationCalls = 'TOTAL_CONVERSATION_CALLS',
  TotalConversationCallTime = 'TOTAL_CONVERSATION_CALL_TIME',
  TotalExpiredAssignTests = 'TOTAL_EXPIRED_ASSIGN_TESTS',
  TotalSelfStudyTime = 'TOTAL_SELF_STUDY_TIME',
  TotalStudyTime = 'TOTAL_STUDY_TIME',
  TotalUncompletedAssignTests = 'TOTAL_UNCOMPLETED_ASSIGN_TESTS',
  UncompletedAssignTestsRate = 'UNCOMPLETED_ASSIGN_TESTS_RATE',
  UniqueSelfPracticeDoneCount = 'UNIQUE_SELF_PRACTICE_DONE_COUNT'
}

export type PartnerRollupTeacherFilter = {
  displayNameQ?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  studentCompletedAssignTestsRate?: InputMaybe<FloatRange>;
};

export type PartnerRollupTeacherOrder = {
  direction: OrderDirection;
  key: PartnerRollupTeacherOrderKey;
};

export enum PartnerRollupTeacherOrderKey {
  AssignTests = 'ASSIGN_TESTS',
  AvgAccuracy = 'AVG_ACCURACY',
  CompletedAssignTests = 'COMPLETED_ASSIGN_TESTS',
  CompletedTests = 'COMPLETED_TESTS',
  DisplayName = 'DISPLAY_NAME',
  GrowthRate = 'GROWTH_RATE',
  PerformanceScore = 'PERFORMANCE_SCORE',
  StudentAssignedAssignTests = 'STUDENT_ASSIGNED_ASSIGN_TESTS',
  StudentCompletedAssignTestsRate = 'STUDENT_COMPLETED_ASSIGN_TESTS_RATE',
  StudentCount = 'STUDENT_COUNT',
  StudentUncompletedAssignTests = 'STUDENT_UNCOMPLETED_ASSIGN_TESTS',
  StudyTime = 'STUDY_TIME'
}

export type PartnerSchoolDocumentCreateInput = {
  fileId?: InputMaybe<Scalars['String']['input']>;
  fileType: SchoolDocumentFileType;
  levels?: InputMaybe<Array<CefrLevel>>;
  thumbnailId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userImageId?: InputMaybe<Scalars['String']['input']>;
  userText?: InputMaybe<Scalars['String']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerSchoolDocumentUpdateInput = {
  id: Scalars['ID']['input'];
  levels?: InputMaybe<Array<CefrLevel>>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<SchoolDocumentVisibility>;
};

export type PartnerSchoolDocumentVisibleInput = {
  ids: Array<Scalars['ID']['input']>;
  visibility?: InputMaybe<SchoolDocumentVisibility>;
};

export type PartnerStudentChartInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PartnerStudentListInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PartnerStudyTimeChartInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  skills?: InputMaybe<Array<InputMaybe<EnglishSkillV1>>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  studentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
  testLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<TypeAttempt>;
  typeAttempts?: InputMaybe<Array<TypeAttempt>>;
};

export type PartnerStudyTimeRankingInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  listClass?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerSubscriptionFilter = {
  hasPartnerPackageWith?: InputMaybe<PartnerPackageFilter>;
  hasUserWith?: InputMaybe<UserFilter>;
};

export type PartnerTeacherCommentPracticePartAttemptInput = {
  feedbackTeacherAudioId?: InputMaybe<Scalars['ID']['input']>;
  feedbackTeacherCommentHtml?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type PartnerTeacherGradePracticeAttemptInput = {
  id: Scalars['ID']['input'];
  teacherComment?: InputMaybe<Scalars['String']['input']>;
  teacherCommentAudioId?: InputMaybe<Scalars['ID']['input']>;
  teacherGrade?: InputMaybe<Scalars['Float']['input']>;
};

export type PartnerTeacherMarkPointExamInput = {
  speakingInput?: InputMaybe<SpeakingUpdateInput>;
  teacherAudioAnswerID?: InputMaybe<Scalars['String']['input']>;
  teacherComment?: InputMaybe<Scalars['String']['input']>;
  teacherGrade?: InputMaybe<Scalars['Float']['input']>;
  typeMark: TypeMark;
  userAttemptID: Scalars['ID']['input'];
  writingIeltsInput?: InputMaybe<Array<IeltsWritingScoringPartInput>>;
  writingInput?: InputMaybe<Array<WritingUpdateInput>>;
};

export type PartnerTeacherSchoolStudentFilter = {
  classId?: InputMaybe<Array<Scalars['ID']['input']>>;
  classNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  displayNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  teacherProfileId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerTeacherSchoolStudentOrder = {
  key?: InputMaybe<PartnerTeacherSchoolStudentOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PartnerTeacherSchoolStudentOrderKey {
  AvgTestAccuracy = 'AVG_TEST_ACCURACY',
  AvgTestScore = 'AVG_TEST_SCORE',
  ClassName = 'CLASS_NAME',
  DisplayName = 'DISPLAY_NAME',
  Email = 'EMAIL',
  JoinedDate = 'JOINED_DATE',
  PhoneNumber = 'PHONE_NUMBER',
  SubscriptionExpiresAt = 'SUBSCRIPTION_EXPIRES_AT',
  TotalAssignTests = 'TOTAL_ASSIGN_TESTS',
  TotalCompletedAssignTests = 'TOTAL_COMPLETED_ASSIGN_TESTS',
  TotalCompletedTests = 'TOTAL_COMPLETED_TESTS',
  TotalExpiredAssignTests = 'TOTAL_EXPIRED_ASSIGN_TESTS',
  TotalStudyTime = 'TOTAL_STUDY_TIME',
  TotalUncompletedAssignTests = 'TOTAL_UNCOMPLETED_ASSIGN_TESTS'
}

export type PartnerViewerAiChatInput = {
  message: Scalars['String']['input'];
  threadId: Scalars['ID']['input'];
};

export type PartnerViewerAiSpeakingRecordUpdateInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type PartnerViewerAiThreadCreateInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerAiThreadDeleteInput = {
  threadId: Scalars['ID']['input'];
};

export type PartnerViewerAiThreadUpdateInput = {
  threadId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerAiWritingRecordUpdateInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type PartnerViewerAcceptLeaveClassInput = {
  notificationId: Scalars['ID']['input'];
};

export type PartnerViewerActivatePlanStudentsInput = {
  flyerPackageId?: InputMaybe<Scalars['ID']['input']>;
  ieltsBand?: InputMaybe<IeltsBand>;
  partnerPackageId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};

export type PartnerViewerAssignTestDeleteInput = {
  assignTestID: Scalars['ID']['input'];
};

export type PartnerViewerAssignTestReAssignInput = {
  assignTestId: Scalars['ID']['input'];
  studentId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerViewerAssignTestRemindParentInput = {
  assignTestId: Scalars['ID']['input'];
  studentId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerViewerAssignTestRemindStudentInput = {
  assignTestId: Scalars['ID']['input'];
  studentId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerViewerAssignTestScoreAttemptsInput = {
  assignTestId: Scalars['ID']['input'];
  userAttemptIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerViewerBingoImageCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  titleEn: Scalars['String']['input'];
  voiceId?: InputMaybe<Scalars['ID']['input']>;
};

export type PartnerViewerBingoImageDeleteInput = {
  id: Scalars['ID']['input'];
};

export type PartnerViewerBingoImageUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
  voiceId?: InputMaybe<Scalars['ID']['input']>;
};

export type PartnerViewerBingoSubjectCreateInput = {
  addBingoSubjectImages?: InputMaybe<Array<BingoSubjectImageCreateInput>>;
  addLearningOutcomeSubjects?: InputMaybe<Array<LearningOutcomeSubjectCreateInput>>;
  appTypes?: InputMaybe<Array<AppType>>;
  bingoImageId?: InputMaybe<Scalars['ID']['input']>;
  boardShow?: InputMaybe<BingoSubjectBoardShow>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['String']['input'];
  level?: InputMaybe<CefrLevel>;
  promptAi: Scalars['String']['input'];
  rawTopic?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  titleEn: Scalars['String']['input'];
  topicId?: InputMaybe<Scalars['ID']['input']>;
};

export type PartnerViewerBingoSubjectDeleteInput = {
  id: Scalars['ID']['input'];
};

export type PartnerViewerBingoSubjectUpdateInput = {
  addBingoSubjectImages?: InputMaybe<Array<BingoSubjectImageCreateInput>>;
  addLearningOutcomeSubjects?: InputMaybe<Array<LearningOutcomeSubjectCreateInput>>;
  appTypes?: InputMaybe<Array<AppType>>;
  bingoImageId?: InputMaybe<Scalars['ID']['input']>;
  boardShow?: InputMaybe<BingoSubjectBoardShow>;
  deleteBingoSubjectImages?: InputMaybe<Array<Scalars['ID']['input']>>;
  deleteLearningOutcomeSubjects?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<CefrLevel>;
  promptAi?: InputMaybe<Scalars['String']['input']>;
  rawTopic?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
  topicId?: InputMaybe<Scalars['ID']['input']>;
  updateBingoSubjectImages?: InputMaybe<Array<BingoSubjectImageUpdateInput>>;
  updateLearningOutcomeSubjects?: InputMaybe<Array<LearningOutcomeSubjectUpdateInput>>;
};

export type PartnerViewerCalendarEventCreateInput = {
  assignTestID?: InputMaybe<Scalars['ID']['input']>;
  classID?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventType?: InputMaybe<CalendarEventEventType>;
  recurrence?: InputMaybe<RecurrenceInput>;
  remindTimeBefore?: InputMaybe<Scalars['Duration']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerCalendarEventTimeUpdateInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  remindTimeBefore?: InputMaybe<Scalars['Duration']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerCalendarEventUpdateInput = {
  assignTestID?: InputMaybe<Scalars['ID']['input']>;
  classID?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventType?: InputMaybe<CalendarEventEventType>;
  id: Scalars['ID']['input'];
  recurrence?: InputMaybe<RecurrenceInput>;
  remindTimeBefore?: InputMaybe<Scalars['Duration']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerChallengeCreateInput = {
  checkPointId: Scalars['ID']['input'];
  disabledPassword?: InputMaybe<Scalars['Boolean']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenName?: InputMaybe<Scalars['Boolean']['input']>;
  isLimit?: InputMaybe<Scalars['Boolean']['input']>;
  isMixed?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<ChallengeSettingsInput>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PartnerViewerChallengeEndInput = {
  challengeId: Scalars['ID']['input'];
};

export type PartnerViewerChallengeInviteInput = {
  challengeId: Scalars['ID']['input'];
  classIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  studentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerViewerChallengeStartInput = {
  challengeId: Scalars['ID']['input'];
};

export type PartnerViewerChallengeUpdateInput = {
  challengeId: Scalars['ID']['input'];
  disabledPassword?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerClassDeleteInput = {
  id: Scalars['ID']['input'];
};

export type PartnerViewerClassStudentUpdateInput = {
  customName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  targetScore?: InputMaybe<Scalars['Int']['input']>;
  testLevelId?: InputMaybe<Scalars['ID']['input']>;
};

export type PartnerViewerClassTimetableDayInput = {
  /** Giờ tan, dạng HH:MM. Phải sau startTime. */
  endTime: Scalars['String']['input'];
  /** Giờ treo tường của lớp, dạng HH:MM. Ví dụ "18:00". */
  startTime: Scalars['String']['input'];
  weekDay: RecurrenceWeekDay;
};

export type PartnerViewerClassTimetableUpsertInput = {
  classId: Scalars['ID']['input'];
  days: Array<PartnerViewerClassTimetableDayInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  remindTimeBefore?: InputMaybe<Scalars['Duration']['input']>;
  /** Ngày hiệu lực. Chỉ phần ngày được dùng; giờ học nằm ở từng days. */
  startDate: Scalars['DateTime']['input'];
  /** null là tạo mới. Có giá trị là sửa cả bộ đó. */
  timetableId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** Ngày kết thúc khoá. Bỏ trống thì mặc định 6 tháng kể từ startDate. */
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PartnerViewerCloneVoiceInput = {
  audioId: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Gender of the cloned voice, also pushed to Inworld. Defaults to `neutral`. */
  gender?: InputMaybe<TtsVoiceGender>;
};

export type PartnerViewerCustomDomainUpdateInput = {
  examBackgroundImageID?: InputMaybe<Scalars['String']['input']>;
  examLogoImageID?: InputMaybe<Scalars['String']['input']>;
  featureDescription?: InputMaybe<Scalars['String']['input']>;
  featureImageId?: InputMaybe<Scalars['String']['input']>;
  featureTitle?: InputMaybe<Scalars['String']['input']>;
  loginTitle?: InputMaybe<Scalars['String']['input']>;
  loginTitleEn?: InputMaybe<Scalars['String']['input']>;
  logoImageId?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerFeaturedPlaylistCheckPointAddInput = {
  checkPointId: Array<Scalars['ID']['input']>;
  featuredPlaylistIds: Array<Scalars['ID']['input']>;
};

export type PartnerViewerFeaturedPlaylistCheckPointRemoveInput = {
  checkPointIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featuredPlaylistId: Scalars['ID']['input'];
};

export type PartnerViewerFeaturedPlaylistCheckPointUpdateInput = {
  featuredPlaylistId: Scalars['ID']['input'];
  updateOrders: Array<PartnerViewerFeaturedPlaylistCheckPointUpdateOrder>;
};

export type PartnerViewerFeaturedPlaylistCheckPointUpdateOrder = {
  checkPointId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type PartnerViewerFeaturedPlaylistCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  levels: Array<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishMode?: InputMaybe<FeaturedPlaylistPublishMode>;
  title: Scalars['String']['input'];
  titleEn: Scalars['String']['input'];
};

export type PartnerViewerFeaturedPlaylistDeleteInput = {
  id: Scalars['ID']['input'];
};

export type PartnerViewerFeaturedPlaylistUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  levels?: InputMaybe<Array<Scalars['String']['input']>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishMode?: InputMaybe<FeaturedPlaylistPublishMode>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerInviteNewStudentsInput = {
  classId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};

export type PartnerViewerInviteStudentToClassInput = {
  classCode?: InputMaybe<Scalars['String']['input']>;
  listEmails: Array<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerInviteTeachersSendInput = {
  emails: Array<Scalars['String']['input']>;
  link: Scalars['String']['input'];
};

export type PartnerViewerMoveClassStudentInput = {
  classId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};

export type PartnerViewerRefundPlanStudentsInput = {
  studentIds: Array<Scalars['ID']['input']>;
};

export type PartnerViewerRejectLeaveClassInput = {
  notificationId: Scalars['ID']['input'];
};

export type PartnerViewerResetPasswordStudentInput = {
  password: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type PartnerViewerRolePermissionUpdateInput = {
  active: Scalars['Boolean']['input'];
  permissionId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

export type PartnerViewerScoreAttemptsInput = {
  teacherExamSessionId: Scalars['ID']['input'];
  userAttemptIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerViewerScoreSpeakingAiInput = {
  learnerProfileId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  recordId?: InputMaybe<Scalars['String']['input']>;
  sampleBand?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AiSpeakingRecordType>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerScoreWritingAiDetailedInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  imageOCRs?: InputMaybe<Array<Scalars['ID']['input']>>;
  learnerProfileId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  sampleBand?: InputMaybe<Scalars['String']['input']>;
  task: AiWritingRecordTask;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerScoreWritingAiImageInput = {
  imageIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  task: AiWritingRecordTask;
};

export type PartnerViewerScoreWritingAiInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  imageOCRs?: InputMaybe<Array<Scalars['ID']['input']>>;
  learnerProfileId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  task: AiWritingRecordTask;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerScoreWritingTeacherDetailedInput = {
  id: Scalars['ID']['input'];
  sampleHTML?: InputMaybe<Scalars['String']['input']>;
  teacherDetailedFeedback?: InputMaybe<DetailedFeedbackInput>;
  teacherNote?: InputMaybe<Scalars['String']['input']>;
  teacherWritingKetPetFeedback?: InputMaybe<KetPetWritingAssessmentInput>;
};

export type PartnerViewerSendResultChallengeInput = {
  studentId: Scalars['ID']['input'];
  userAttemptId: Scalars['ID']['input'];
};

export type PartnerViewerSentEmailStudentInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type PartnerViewerStudentCreateInput = {
  classId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  flyerPackageId?: InputMaybe<Scalars['ID']['input']>;
  ieltsBand?: InputMaybe<IeltsBand>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  partnerPackageId?: InputMaybe<Scalars['ID']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
  trialPlan?: Scalars['Boolean']['input'];
  username: Scalars['String']['input'];
};

export type PartnerViewerStudentDeleteInput = {
  classId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};

export type PartnerViewerStudentTestScoreFilter = {
  testLevelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerViewerStudentUpdateInput = {
  classId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  learnerProfileId: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  removeClassId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerViewerTransferSchoolWalletInput = {
  amount: Scalars['Float']['input'];
  toSchoolId: Scalars['ID']['input'];
};

export type PartnerWeeklyClassAssignTestWeakFilter = {
  className?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerWeeklyClassStudyWeakFilter = {
  className?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerWeeklyStudentAssignTestWeakFilter = {
  classId?: InputMaybe<Array<Scalars['ID']['input']>>;
  studentName?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PartnerWeeklyTeacherAssignTestWeakFilter = {
  classId?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherName?: InputMaybe<Scalars['String']['input']>;
};

export enum PaymentCreateVnpPackageInput {
  DiamondBasic = 'DIAMOND_BASIC',
  DiamondTrial = 'DIAMOND_TRIAL',
  DiamondWell = 'DIAMOND_WELL',
  FlyerIeltsOneYear = 'FLYER_IELTS_ONE_YEAR',
  FlyerIeltsSixMonths = 'FLYER_IELTS_SIX_MONTHS',
  FlyerIeltsThreeMonths = 'FLYER_IELTS_THREE_MONTHS',
  FlyerKidsFourYears = 'FLYER_KIDS_FOUR_YEARS',
  FlyerKidsOneYear = 'FLYER_KIDS_ONE_YEAR',
  FlyerKidsTwoYears = 'FLYER_KIDS_TWO_YEARS',
  FlyerMaxFourYears = 'FLYER_MAX_FOUR_YEARS',
  FlyerMaxOneYear = 'FLYER_MAX_ONE_YEAR',
  FlyerMaxSixMonths = 'FLYER_MAX_SIX_MONTHS',
  FlyerMaxThreeYears = 'FLYER_MAX_THREE_YEARS',
  FlyerMaxTwoYears = 'FLYER_MAX_TWO_YEARS',
  FlyerTeensFourYears = 'FLYER_TEENS_FOUR_YEARS',
  FlyerTeensOneYear = 'FLYER_TEENS_ONE_YEAR',
  FlyerTeensTwoYears = 'FLYER_TEENS_TWO_YEARS',
  OneDay = 'ONE_DAY',
  PartnerDepositWallet = 'PARTNER_DEPOSIT_WALLET',
  PartnerSpeakingAi = 'PARTNER_SPEAKING_AI',
  TeadoTool = 'TEADO_TOOL',
  TeadoToolPlus = 'TEADO_TOOL_PLUS'
}

export enum PaymentCreateVnpSourceInput {
  Exam = 'EXAM',
  Ielts = 'IELTS',
  Mobile = 'MOBILE',
  Partner = 'PARTNER',
  Web = 'WEB'
}

export type PaymentCreateVnpUrlInput = {
  bankCode?: InputMaybe<Scalars['String']['input']>;
  callback: Scalars['String']['input'];
  discountCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  learnerProfileId?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<PaymentLocaleVnp>;
  orderInfo: Scalars['String']['input'];
  package: PaymentCreateVnpPackageInput;
  partnerForSchoolId?: InputMaybe<Scalars['ID']['input']>;
  partnerPackageId?: InputMaybe<Scalars['ID']['input']>;
  partnerTotalDiamond?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  source: PaymentCreateVnpSourceInput;
  teacherProfileId?: InputMaybe<Scalars['ID']['input']>;
  teacherSchoolId?: InputMaybe<Scalars['Int']['input']>;
  testLevelId?: InputMaybe<Scalars['ID']['input']>;
  userAddress?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userIdentityCard?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentGetStatusVnpInput = {
  txnRef: Scalars['String']['input'];
};

export enum PaymentLocaleVnp {
  En = 'EN',
  Vn = 'VN'
}

export enum PaymentStudentActivitiesBillingStatus {
  Expired = 'EXPIRED',
  Free = 'FREE',
  Upgraded = 'UPGRADED'
}

export type PaymentStudentActivitiesFilter = {
  billingStatus?: InputMaybe<Array<PaymentStudentActivitiesBillingStatus>>;
  classes?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  q?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum PaymentStudentActivitiesStatus {
  Create = 'CREATE',
  Extend = 'EXTEND'
}

export type PaymentTeacherPreviewVnpInput = {
  discountCode?: InputMaybe<Scalars['String']['input']>;
  items: Array<PaymentTeacherPreviewVnpItemInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type PaymentTeacherPreviewVnpItemInput = {
  durationMonths?: InputMaybe<Scalars['Int']['input']>;
  numberOfStudents?: InputMaybe<Scalars['Int']['input']>;
  package: PaymentCreateVnpPackageInput;
  partnerPackageId?: InputMaybe<Scalars['ID']['input']>;
  partnerTotalDiamond?: InputMaybe<Scalars['Int']['input']>;
};

export type PlacementTestStepLevelInput = {
  color: Scalars['String']['input'];
  label: Scalars['String']['input'];
  step: Scalars['String']['input'];
  value: CefrLevel;
};

export type PracticeEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type PracticePartBodyInput = {
  details?: InputMaybe<Array<PracticePartDetailInput>>;
  notes?: InputMaybe<Array<PracticePartNoteInput>>;
  query?: InputMaybe<PracticePartQueryInput>;
};

export type PracticePartDetailAnswerInput = {
  detailId: Scalars['ID']['input'];
  markedCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pairs?: InputMaybe<Array<PracticePartDetailAnswerPairInput>>;
  placeholders?: InputMaybe<Array<PracticePartDetailAnswerPlaceholderInput>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PracticePartDetailAnswerPairInput = {
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};

export type PracticePartDetailAnswerPlaceholderInput = {
  optionId: Scalars['ID']['input'];
  placeholderId: Scalars['ID']['input'];
};

export type PracticePartDetailInput = {
  evaluationCriteria?: InputMaybe<PracticePartEvaluationCriteriaInput>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  imagePlaceholders?: InputMaybe<Array<PracticePartImagePlaceholderInput>>;
  maximumWordsAnswer?: InputMaybe<Scalars['Int']['input']>;
  multipleCorrectAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<PracticePartOptionInput>>;
  pairs?: InputMaybe<Array<PracticePartPairInput>>;
};

export type PracticePartEvaluationCriteriaInput = {
  isPartialGrading?: InputMaybe<Scalars['Boolean']['input']>;
  level: CefrLevel;
  rubricHtml: Scalars['String']['input'];
};

export type PracticePartImagePlaceholderInput = {
  height?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  left: Scalars['String']['input'];
  top: Scalars['String']['input'];
  width?: InputMaybe<Scalars['String']['input']>;
};

export enum PracticePartLayout {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

export type PracticePartNoteInput = {
  contentHtml: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  videoTimestamp?: InputMaybe<Scalars['Float']['input']>;
};

export type PracticePartOptionInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  correctAnswer: Scalars['Boolean']['input'];
  correctPlaceholderId?: InputMaybe<Scalars['ID']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PracticePartPairInput = {
  from: PracticePartOptionInput;
  to: PracticePartOptionInput;
};

export type PracticePartQueryInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  contentHtml: Scalars['String']['input'];
  fileId?: InputMaybe<Scalars['ID']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  videoEndTime?: InputMaybe<Scalars['Float']['input']>;
  videoStartTime?: InputMaybe<Scalars['Float']['input']>;
  videoTimestamp?: InputMaybe<Scalars['Float']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum PracticePartType {
  AudioResponse = 'AUDIO_RESPONSE',
  AudioResponsePage = 'AUDIO_RESPONSE_PAGE',
  DragDrop = 'DRAG_DROP',
  Dropdown = 'DROPDOWN',
  Flashcard = 'FLASHCARD',
  Gapfill = 'GAPFILL',
  InteractiveVideo = 'INTERACTIVE_VIDEO',
  Match = 'MATCH',
  Multichoice = 'MULTICHOICE',
  OpenEnded = 'OPEN_ENDED',
  Passage = 'PASSAGE',
  Reorder = 'REORDER',
  WordOrdering = 'WORD_ORDERING'
}

export type PracticeStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  bookLessonId?: InputMaybe<Scalars['ID']['input']>;
  challengeCode?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
};

export type PracticeSubmitPartAttemptInput = {
  answers?: InputMaybe<Array<PracticePartDetailAnswerInput>>;
  attemptId: Scalars['ID']['input'];
  audioResponseRecordId?: InputMaybe<Scalars['ID']['input']>;
  partId: Scalars['ID']['input'];
};

export enum RankFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum RecurrenceFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type RecurrenceInput = {
  byMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  byMonthDay?: InputMaybe<Array<Scalars['Int']['input']>>;
  byWeekDay?: InputMaybe<Array<RecurrenceWeekDay>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  frequency: RecurrenceFrequency;
  interval?: InputMaybe<Scalars['Int']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum RecurrenceWeekDay {
  Fr = 'FR',
  Mo = 'MO',
  Sa = 'SA',
  Su = 'SU',
  Th = 'TH',
  Tu = 'TU',
  We = 'WE'
}

export enum RefTaskName {
  TakeTest = 'TAKE_TEST',
  TeacherDepositDiamonds = 'TEACHER_DEPOSIT_DIAMONDS',
  TeacherSignUp = 'TEACHER_SIGN_UP',
  UpgradeAccount = 'UPGRADE_ACCOUNT'
}

export enum RequestReview {
  Ai = 'AI',
  Teacher = 'TEACHER'
}

export type ResultStatementCommentCreateInput = {
  content: Scalars['String']['input'];
  contentEn: Scalars['String']['input'];
};

export type ResultStatementCommentDeleteInput = {
  id: Scalars['ID']['input'];
};

export type ResultStatementCommentUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  contentEn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type ResultStatementCreateInput = {
  commentId: Scalars['ID']['input'];
  examStructureType: ExamStructureType;
  from: Scalars['Int']['input'];
  order: Scalars['Int']['input'];
  testLevelId: Scalars['ID']['input'];
  titleType: ResultStatementTitleType;
  to: Scalars['Int']['input'];
};

export type ResultStatementDeleteInput = {
  id: Scalars['ID']['input'];
};

export enum ResultStatementTitleType {
  ImprovementActions = 'IMPROVEMENT_ACTIONS',
  ImprovementAreas = 'IMPROVEMENT_AREAS',
  StrengthsInEnglish = 'STRENGTHS_IN_ENGLISH'
}

export type ResultStatementUpdateInput = {
  commentId?: InputMaybe<Scalars['ID']['input']>;
  examStructureType?: InputMaybe<ExamStructureType>;
  from?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  testLevelId?: InputMaybe<Scalars['ID']['input']>;
  titleType?: InputMaybe<ResultStatementTitleType>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolDocumentCustomFilter = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export enum SchoolDocumentFileType {
  Docx = 'DOCX',
  Image = 'IMAGE',
  Pdf = 'PDF',
  Pptx = 'PPTX',
  Text = 'TEXT',
  Youtube = 'YOUTUBE'
}

export type SchoolDocumentFilter = {
  and?: InputMaybe<Array<SchoolDocumentFilter>>;
  fileType?: InputMaybe<Array<SchoolDocumentFileType>>;
  hasSchoolWith?: InputMaybe<SchoolFilter>;
  hasTeacherProfileWith?: InputMaybe<TeacherProfileFilter>;
  levels?: InputMaybe<Array<InputMaybe<CefrLevel>>>;
  or?: InputMaybe<Array<SchoolDocumentFilter>>;
  q?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Array<SourceSchoolDocument>>;
  status?: InputMaybe<Array<SchoolDocumentStatus>>;
  titleQ?: InputMaybe<Array<Scalars['String']['input']>>;
  visibility?: InputMaybe<Array<SchoolDocumentVisibility>>;
};

export type SchoolDocumentOrder = {
  key?: InputMaybe<SchoolDocumentOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SchoolDocumentOrderKey {
  Recently = 'RECENTLY'
}

export enum SchoolDocumentStatus {
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Ready = 'READY'
}

export enum SchoolDocumentVisibility {
  Community = 'COMMUNITY',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum SchoolEducationType {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type SchoolFilter = {
  and?: InputMaybe<Array<SchoolFilter>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<SchoolFilter>>;
  provinceId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SchoolInvitedTeacherFilter = {
  q?: InputMaybe<Array<Scalars['String']['input']>>;
  roleId?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<SchoolInvitedTeacherStatus>>;
};

export type SchoolInvitedTeacherOrder = {
  key: SchoolInvitedTeacherOrderKey;
  reverse?: Scalars['Boolean']['input'];
};

export enum SchoolInvitedTeacherOrderKey {
  Status = 'STATUS'
}

export enum SchoolInvitedTeacherStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  PendingApproval = 'PENDING_APPROVAL'
}

export type SchoolRoleUpdateInput = {
  admin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  teacher?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum SchoolStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type SchoolTestLevelRankFilter = {
  provinceId?: InputMaybe<Array<Scalars['ID']['input']>>;
  schoolId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SentenceSuggestionInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  originalSentence?: InputMaybe<Scalars['String']['input']>;
  suggestedText?: InputMaybe<Scalars['String']['input']>;
  textChanges?: InputMaybe<Array<InputMaybe<TextChangeInput>>>;
};

export enum SourceBingo {
  All = 'ALL',
  Community = 'COMMUNITY',
  Domain = 'DOMAIN',
  Flyer = 'FLYER',
  OnlyMe = 'ONLY_ME'
}

export enum SourceSchool {
  All = 'ALL',
  Community = 'COMMUNITY',
  Domain = 'DOMAIN',
  Flyer = 'FLYER',
  OnlyMe = 'ONLY_ME'
}

export enum SourceSchoolDocument {
  All = 'ALL',
  Community = 'COMMUNITY',
  Domain = 'DOMAIN',
  Flyer = 'FLYER',
  OnlyMe = 'ONLY_ME'
}

export type SpeakingEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type SpeakingImageInput = {
  height?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['ID']['input'];
  left?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  top?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type SpeakingPartBodyInput = {
  candidateImageId?: InputMaybe<Scalars['ID']['input']>;
  candidateSheet?: InputMaybe<SpeakingSheetInput>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  contentImageId?: InputMaybe<Scalars['ID']['input']>;
  contentImagePrompt?: InputMaybe<Scalars['String']['input']>;
  examinerImageId?: InputMaybe<Scalars['ID']['input']>;
  examinerSheet?: InputMaybe<SpeakingSheetInput>;
  images?: InputMaybe<Array<SpeakingImageInput>>;
  placeholders?: InputMaybe<Array<SpeakingPlaceholderInput>>;
  points?: InputMaybe<Array<SpeakingPointInput>>;
};

export type SpeakingPartFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  partType?: InputMaybe<Array<SpeakingPartType>>;
};

export enum SpeakingPartType {
  Discussion = 'discussion',
  FindDifferences = 'find_differences',
  FindObject_1 = 'find_object_1',
  FindObject_2 = 'find_object_2',
  InfoExchange = 'info_exchange',
  InterviewOpinion = 'interview_opinion',
  MoveObject = 'move_object',
  ObjectCard = 'object_card',
  OddOneOut = 'odd_one_out',
  PersonalQuestions = 'personal_questions',
  PicStory = 'pic_story',
  PictureDescription = 'picture_description',
  SceneCard = 'scene_card'
}

export type SpeakingPlaceholderInput = {
  height: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  left: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  top: Scalars['String']['input'];
  width: Scalars['String']['input'];
};

export type SpeakingPointInput = {
  id: Scalars['ID']['input'];
  left: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  top: Scalars['String']['input'];
};

export enum SpeakingQuestionAttemptDiscussionRole {
  Bingo = 'BINGO',
  User = 'USER'
}

export type SpeakingQuestionBodyInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  contentImageId?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<SpeakingImageInput>>;
};

export type SpeakingQuestionCreateInput = {
  answerImageId?: InputMaybe<Scalars['ID']['input']>;
  answerPlaceholderId?: InputMaybe<Scalars['ID']['input']>;
  audioId: Scalars['ID']['input'];
  audioSubtitle?: InputMaybe<Scalars['String']['input']>;
  bingoAudioId?: InputMaybe<Scalars['String']['input']>;
  bingoAudioSubtitle?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<SpeakingQuestionBodyInput>;
  contextPrompt?: InputMaybe<Scalars['String']['input']>;
  groupPosition?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxScore: Scalars['Float']['input'];
  needsRecordAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  needsScore?: InputMaybe<Scalars['Boolean']['input']>;
  numberCorrectKey?: InputMaybe<Scalars['Int']['input']>;
  position: Scalars['Int']['input'];
  recommendSentences?: InputMaybe<Array<InputMaybe<SpeakingQuestionRecommendSentenceInput>>>;
  timeToSpeak?: InputMaybe<Scalars['Duration']['input']>;
  turnCountDiscussion?: InputMaybe<Scalars['Int']['input']>;
};

export enum SpeakingQuestionDiscussionAttemptRole {
  Bingo = 'BINGO',
  User = 'USER'
}

export type SpeakingQuestionRecommendSentenceInput = {
  audioId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type SpeakingQuestionUpdateInput = {
  answerImageId?: InputMaybe<Scalars['ID']['input']>;
  answerPlaceholderId?: InputMaybe<Scalars['ID']['input']>;
  audioId?: InputMaybe<Scalars['ID']['input']>;
  audioSubtitle?: InputMaybe<Scalars['String']['input']>;
  bingoAudioId?: InputMaybe<Scalars['String']['input']>;
  bingoAudioSubtitle?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<SpeakingQuestionBodyInput>;
  contextPrompt?: InputMaybe<Scalars['String']['input']>;
  groupPosition?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxScore?: InputMaybe<Scalars['Float']['input']>;
  needsRecordAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  needsScore?: InputMaybe<Scalars['Boolean']['input']>;
  numberCorrectKey?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  recommendSentences?: InputMaybe<Array<InputMaybe<SpeakingQuestionRecommendSentenceInput>>>;
  timeToSpeak?: InputMaybe<Scalars['Duration']['input']>;
  turnCountDiscussion?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakingSheetContentInput = {
  id: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SpeakingSheetInput = {
  sheets: Array<SpeakingSheetContentInput>;
  title: Scalars['String']['input'];
};

export type SpeakingStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  bookLessonId?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  device?: InputMaybe<UserAttemptDevice>;
  requestAIAzure?: InputMaybe<Scalars['Boolean']['input']>;
  requestAIAzureDiamond?: InputMaybe<Scalars['Boolean']['input']>;
  requestAIReview?: InputMaybe<Scalars['Boolean']['input']>;
  requestReview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpeakingSubmitDiscussionQuestionAttemptInput = {
  attemptId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  recordId?: InputMaybe<Scalars['ID']['input']>;
};

export type SpeakingSubmitQuestionAttemptInput = {
  attemptId: Scalars['ID']['input'];
  audioReplayCount?: InputMaybe<Scalars['Int']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  placeholderId?: InputMaybe<Scalars['ID']['input']>;
  questionId: Scalars['ID']['input'];
  recordId?: InputMaybe<Scalars['ID']['input']>;
  transcriptionRecord?: InputMaybe<Scalars['String']['input']>;
};

export type SpeakingUpdateInput = {
  questionAttemptID: Scalars['ID']['input'];
  teacherAudioAnswerQuestionAttemptID?: InputMaybe<Scalars['String']['input']>;
  teacherComment?: InputMaybe<Scalars['String']['input']>;
};

export type StandardFeedbackInput = {
  evaluationKey?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  feedbackVi?: InputMaybe<Scalars['String']['input']>;
  improve?: InputMaybe<Scalars['String']['input']>;
  improveVi?: InputMaybe<Scalars['String']['input']>;
};

export enum Status {
  Active = 'ACTIVE',
  InActive = 'IN_ACTIVE'
}

export enum StatusAssignTest {
  Done = 'DONE',
  NoneStarted = 'NONE_STARTED',
  Progress = 'PROGRESS'
}

export enum StatusAttempt {
  GotScore = 'GOT_SCORE',
  NewScore = 'NEW_SCORE',
  NoScore = 'NO_SCORE'
}

export enum StatusLearnerMistakeWord {
  Completed = 'COMPLETED',
  Correct = 'CORRECT',
  Incorrect = 'INCORRECT',
  ReMark = 'RE_MARK',
  UnCompleted = 'UN_COMPLETED',
  Warning = 'WARNING'
}

export enum StatusStudent {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotSubmit = 'NOT_SUBMIT'
}

export enum StudentAssignTestStatus {
  Done = 'DONE',
  Uncompleted = 'UNCOMPLETED'
}

export enum StudentCreateType {
  Exam = 'EXAM',
  Ielts = 'IELTS'
}

export type StudyCharacterFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum SubscriptionStatus {
  Expire = 'EXPIRE',
  NotSubscription = 'NOT_SUBSCRIPTION',
  Subscription = 'SUBSCRIPTION'
}

export enum SubscriptionStatusFilter {
  Expire = 'EXPIRE',
  NotSubscription = 'NOT_SUBSCRIPTION',
  Subscription = 'SUBSCRIPTION'
}

export type TaskAchievementBreakdownInput = {
  appropriateFormat?: InputMaybe<StandardFeedbackInput>;
  coversAllParts?: InputMaybe<StandardFeedbackInput>;
  dataAndSupport?: InputMaybe<StandardFeedbackInput>;
  providesClearOverview?: InputMaybe<StandardFeedbackInput>;
  selectsKeyFeatures?: InputMaybe<StandardFeedbackInput>;
};

export type TaskResponseBreakdownInput = {
  appropriateFormat?: InputMaybe<StandardFeedbackInput>;
  clearPosition?: InputMaybe<StandardFeedbackInput>;
  ideaDevelopment?: InputMaybe<StandardFeedbackInput>;
  taskFulfilment?: InputMaybe<StandardFeedbackInput>;
};

export type TeacherByDayFilter = {
  date?: InputMaybe<DateTimeRange>;
};

export type TeacherCommentDetailInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  quote: Scalars['String']['input'];
};

export type TeacherInvitationInput = {
  fromTeacherId: Scalars['ID']['input'];
  schoolId: Scalars['ID']['input'];
};

export type TeacherOverviewInput = {
  crypto: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type TeacherProfileFilter = {
  canAssignToClassId?: InputMaybe<Array<Scalars['ID']['input']>>;
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  displayNameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  hasCustomDomainWith?: InputMaybe<CustomDomainFilter>;
  hasSchoolsWith?: InputMaybe<TeacherProfileSchoolFilter>;
  hasUserWith?: InputMaybe<UserFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TeacherProfileOrder = {
  key?: InputMaybe<TeacherProfileOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TeacherProfileOrderKey {
  DisplayName = 'DISPLAY_NAME',
  Wallet = 'WALLET'
}

export type TeacherProfileSchoolFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum TeacherProfileType {
  Normal = 'NORMAL',
  Tool = 'TOOL'
}

export type TestLevelFilter = {
  and?: InputMaybe<Array<TestLevelFilter>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  isSpeaking?: InputMaybe<Scalars['Boolean']['input']>;
  isVocabulary?: InputMaybe<Scalars['Boolean']['input']>;
  isWriting?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<CefrLevel>>;
  not?: InputMaybe<TestLevelFilter>;
  or?: InputMaybe<Array<TestLevelFilter>>;
  slug?: InputMaybe<Array<Scalars['String']['input']>>;
  slugQ?: InputMaybe<Array<Scalars['String']['input']>>;
  typeTestLevel?: InputMaybe<Array<TypeExamTestLevel>>;
};

export type TestLevelMetaInput = {
  externalLink?: InputMaybe<Scalars['String']['input']>;
  seo?: InputMaybe<TestLevelMetaSeoInput>;
};

export type TestLevelMetaSeoInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  featureImageId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
};

export enum TestLevelModeValue {
  Discussion = 'DISCUSSION',
  Exam = 'EXAM',
  MiniTest = 'MINI_TEST',
  Quiz = 'QUIZ',
  Speaking = 'SPEAKING',
  Vocabulary = 'VOCABULARY',
  Writing = 'WRITING'
}

export type TestLevelOrder = {
  key?: InputMaybe<TestLevelOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TestLevelOrderKey {
  TestLevelOrder = 'TEST_LEVEL_ORDER'
}

export type TextChangeInput = {
  analysis?: InputMaybe<Scalars['String']['input']>;
  analysisVi?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  errorImpact?: InputMaybe<Scalars['String']['input']>;
  originalText?: InputMaybe<Scalars['String']['input']>;
  suggestedText?: InputMaybe<Scalars['String']['input']>;
};

export type TextToSpeakInput = {
  text: Scalars['String']['input'];
};

export type ThemeFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameEnQ?: InputMaybe<Array<Scalars['String']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<ThemeType>>;
};

export enum ThemeType {
  Ielts = 'IELTS',
  Practice = 'PRACTICE',
  Challenge = 'challenge'
}

export enum TokenType {
  Firebase = 'FIREBASE'
}

export type TopicFilter = {
  and?: InputMaybe<Array<TopicFilter>>;
  appTypes?: InputMaybe<Array<AppType>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameEnQ?: InputMaybe<Array<Scalars['String']['input']>>;
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<TopicFilter>>;
};

export enum TtsVoiceCategory {
  Bingo = 'bingo',
  HolyGiong = 'holy_giong',
  Teacher = 'teacher'
}

export enum TtsVoiceCloneStatus {
  Failed = 'failed',
  Processing = 'processing',
  Ready = 'ready'
}

export enum TtsVoiceGender {
  Female = 'female',
  Male = 'male',
  Neutral = 'neutral'
}

export enum TtsVoiceSource {
  Inworld = 'inworld',
  Microsoft = 'microsoft'
}

export enum TypeAttempt {
  BingoSubject = 'BINGO_SUBJECT',
  Exam = 'EXAM',
  ExternalLink = 'EXTERNAL_LINK',
  Ielts = 'IELTS',
  IeltsSpeaking = 'IELTS_SPEAKING',
  PlacementTest = 'PLACEMENT_TEST',
  Practice = 'PRACTICE',
  Speaking = 'SPEAKING',
  Study = 'STUDY',
  Writing = 'WRITING'
}

export enum TypeCheckPointAdmin {
  Exam = 'EXAM',
  Speaking = 'SPEAKING'
}

export enum TypeExamAssignTest {
  Exam = 'exam',
  Mini = 'mini',
  Practice = 'practice',
  Speaking = 'speaking',
  Writing = 'writing'
}

export enum TypeExamTestLevel {
  Classic = 'CLASSIC',
  Ielts = 'IELTS',
  Phadao = 'PHADAO',
  PlacementTest = 'PLACEMENT_TEST',
  Practice = 'PRACTICE'
}

export enum TypeInitAssignTest {
  Class = 'class',
  Student = 'student'
}

export enum TypeMark {
  IeltsWriting = 'IELTS_WRITING',
  Speaking = 'SPEAKING',
  Writing = 'WRITING'
}

export type UserActiveCodeInput = {
  code: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export enum UserAdminRole {
  Admin = 'ADMIN',
  ContentEditor = 'CONTENT_EDITOR',
  Manager = 'MANAGER',
  SuperManager = 'SUPER_MANAGER',
  Tester = 'TESTER',
  Viewer = 'VIEWER'
}

export enum UserAttemptDevice {
  Mobile = 'mobile',
  Web = 'web'
}

export type UserAttemptFilter = {
  checkPointId?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<DateTimeRange>;
  hasAssignTestWith?: InputMaybe<AssignTestFilter>;
  hasChallengeWith?: InputMaybe<ChallengeFilter>;
  hasCheckPointWith?: InputMaybe<CheckPointFilter>;
  hasIelts?: InputMaybe<Scalars['Boolean']['input']>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
  hasTestLevelWith?: InputMaybe<TestLevelFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  isNeedReview?: InputMaybe<Scalars['Boolean']['input']>;
  requestReview?: InputMaybe<Array<RequestReview>>;
  skills?: InputMaybe<Array<EnglishSkillV1>>;
  statusAttempt?: InputMaybe<StatusAttempt>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
  submittedAt?: InputMaybe<DateTimeRange>;
  testLevelID?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeAttempt?: InputMaybe<Array<TypeAttempt>>;
};

/** UserAttemptObjectiveKey is enum for the field objectiveKey */
export enum UserAttemptObjectiveKey {
  CompleteIn_5Min = 'COMPLETE_IN_5_MIN',
  ExactThreeFirstTry = 'EXACT_THREE_FIRST_TRY'
}

export type UserAvatarFrameFilter = {
  hasAvatarFrameWith?: InputMaybe<AvatarFrameFilter>;
  hasLearnerProfileWith?: InputMaybe<LearnerProfileFilter>;
};

export enum UserErrorCode {
  AlreadyExist = 'ALREADY_EXIST',
  AlreadySubmitted = 'ALREADY_SUBMITTED',
  AlreadyUsed = 'ALREADY_USED',
  AttendanceRecorded = 'ATTENDANCE_RECORDED',
  ClassJoinDisabled = 'CLASS_JOIN_DISABLED',
  ContainsInvalidCharacters = 'CONTAINS_INVALID_CHARACTERS',
  ContainsWhiteSpace = 'CONTAINS_WHITE_SPACE',
  Disabled = 'DISABLED',
  Duplicate = 'DUPLICATE',
  EmailAlreadyExist = 'EMAIL_ALREADY_EXIST',
  EmailDuplicated = 'EMAIL_DUPLICATED',
  EmailVerified = 'EMAIL_VERIFIED',
  Empty = 'EMPTY',
  Expired = 'EXPIRED',
  GreaterThan = 'GREATER_THAN',
  InsufficientWalletAmount = 'INSUFFICIENT_WALLET_AMOUNT',
  Invalid = 'INVALID',
  InvalidFormat = 'INVALID_FORMAT',
  LearnerProfileMismatch = 'LEARNER_PROFILE_MISMATCH',
  LessThan = 'LESS_THAN',
  NotEnoughDiamond = 'NOT_ENOUGH_DIAMOND',
  NotFound = 'NOT_FOUND',
  NoPermission = 'NO_PERMISSION',
  NoTextFromAudio = 'NO_TEXT_FROM_AUDIO',
  OutOfTime = 'OUT_OF_TIME',
  PackageNotAvailable = 'PACKAGE_NOT_AVAILABLE',
  PhoneNumberAlreadyExist = 'PHONE_NUMBER_ALREADY_EXIST',
  PhoneNumberDuplicated = 'PHONE_NUMBER_DUPLICATED',
  PhoneNumberVerified = 'PHONE_NUMBER_VERIFIED',
  QuotaLimit = 'QUOTA_LIMIT',
  ReachLimit = 'REACH_LIMIT',
  SectionExpired = 'SECTION_EXPIRED',
  TooLong = 'TOO_LONG',
  TooShort = 'TOO_SHORT',
  TrialExpired = 'TRIAL_EXPIRED',
  TrialNotAvailable = 'TRIAL_NOT_AVAILABLE',
  TryAgainIn = 'TRY_AGAIN_IN',
  UsernameAlreadyExist = 'USERNAME_ALREADY_EXIST',
  UsernameDuplicated = 'USERNAME_DUPLICATED'
}

export type UserFilter = {
  and?: InputMaybe<Array<UserFilter>>;
  createdAt?: InputMaybe<DateTimeRange>;
  emailQ?: InputMaybe<Array<Scalars['String']['input']>>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  hasActivationCodeUsersWith?: InputMaybe<ActivationCodeUserFilter>;
  hasLearnerProfilesWith?: InputMaybe<LearnerProfileFilter>;
  hasTeacherProfilesWith?: InputMaybe<TeacherProfileFilter>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<UserFilter>;
  or?: InputMaybe<Array<UserFilter>>;
  phoneNumberQ?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceDomainQ?: InputMaybe<Array<Scalars['String']['input']>>;
  subscriptionExpiresAt?: InputMaybe<DateTimeRange>;
  teacherVerified?: InputMaybe<Scalars['Boolean']['input']>;
  usernameQ?: InputMaybe<Array<Scalars['String']['input']>>;
  utmCampaignQ?: InputMaybe<Array<Scalars['String']['input']>>;
  utmContentQ?: InputMaybe<Array<Scalars['String']['input']>>;
  utmMediumQ?: InputMaybe<Array<Scalars['String']['input']>>;
  utmSourceQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserGenBulkInput = {
  activationPlan?: InputMaybe<Scalars['String']['input']>;
  addTeacherProfile?: InputMaybe<Scalars['Boolean']['input']>;
  diamond?: InputMaybe<Scalars['Int']['input']>;
  packageID?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  teacherFirstName?: InputMaybe<Scalars['String']['input']>;
  teacherVerified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserGenBulkPhoneInput = {
  activationPlan?: InputMaybe<Scalars['String']['input']>;
  diamond?: InputMaybe<Scalars['Int']['input']>;
  packageID?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers: Array<Scalars['String']['input']>;
};

export type UserGenBulkUserNameInput = {
  classCode?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameTeacher?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

export type UserTeacherReferralUsageFilter = {
  createdAt?: InputMaybe<DateTimeRange>;
  hasUserWith?: InputMaybe<UserFilter>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  paidAt?: InputMaybe<DateTimeRange>;
};

export type VersionNotificationFilter = {
  appType?: InputMaybe<Array<AppTypeMobile>>;
  status?: InputMaybe<Array<Status>>;
  versionQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ViewerAiConversationCompleteInput = {
  audioBase64Url?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  userText?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerAiConversationCreateInput = {
  message: Scalars['String']['input'];
  role: AiConversationRole;
  sessionId: Scalars['ID']['input'];
};

export type ViewerAiConversationSessionCreateInput = {
  assignTestID?: InputMaybe<Scalars['ID']['input']>;
  bingoStudyLevelId?: InputMaybe<Scalars['ID']['input']>;
  bingoSubjectID?: InputMaybe<Scalars['ID']['input']>;
  duolingoLevelId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Device>;
  type?: InputMaybe<AiConversationSessionType>;
};

export type ViewerAiConversationSessionUpdateInput = {
  id: Scalars['ID']['input'];
  isCompleted: Scalars['Boolean']['input'];
};

export type ViewerAiConversationUpdateInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type ViewerActiveCodeInput = {
  code: Scalars['String']['input'];
};

export type ViewerAdviceCreateInput = {
  adviceType: AdviceAdviceType;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  source?: InputMaybe<AdviceSource>;
};

export type ViewerBingoSubjectSuggestionsInput = {
  sessionId: Scalars['ID']['input'];
};

export type ViewerBuyAvatarFrameInput = {
  avatarFrameID: Scalars['ID']['input'];
};

export type ViewerCreateLearnerProfileInput = {
  additionalInfo?: InputMaybe<AdditionalInfoInput>;
  avatarId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  ieltsCurrentScore?: InputMaybe<Scalars['Float']['input']>;
  ieltsExamDate?: InputMaybe<Scalars['DateTime']['input']>;
  ieltsTargetScore?: InputMaybe<Scalars['Float']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onboardingInfo?: InputMaybe<Array<MetaInfoInput>>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerCreateParentProfileInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerCreateTeacherProfileInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  avatarId?: InputMaybe<Scalars['String']['input']>;
  bankAccountInfo?: InputMaybe<BankAccountInfoInput>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  isCurriculumManager?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onboardingInfo?: InputMaybe<Array<MetaInfoInput>>;
  refTeacherId?: InputMaybe<Scalars['ID']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
};

export type ViewerExamSeenNotificationInput = {
  all?: Scalars['Boolean']['input'];
  floatSeen?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerForceLogInByEmailTokenInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  refUserId?: InputMaybe<Scalars['ID']['input']>;
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  tokenType: TokenType;
};

export type ViewerInviteFriendsSendInput = {
  emails: Array<Scalars['String']['input']>;
  link: Scalars['String']['input'];
};

export type ViewerJoinClassInput = {
  classCode: Scalars['String']['input'];
  learnerProfileID?: InputMaybe<Scalars['ID']['input']>;
  leftClassID?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerLogInInput = {
  withFirebaseEmail?: InputMaybe<ViewerLogInWithFirebaseEmailInput>;
  withPassword?: InputMaybe<ViewerLogInWithPasswordInput>;
};

export type ViewerLogInWithFirebaseEmailInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  refUserId?: InputMaybe<Scalars['ID']['input']>;
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type ViewerLogInWithPasswordInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ViewerMistakeWordNoteCreateInput = {
  appType: AppType;
  note: Scalars['String']['input'];
};

export type ViewerMistakeWordRecordScoreInput = {
  mistakeWordId: Scalars['ID']['input'];
};

export type ViewerMistakeWordUpdateInput = {
  id: Scalars['ID']['input'];
  recordId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerPairDeviceInput = {
  /** The device MAC (or the full 'flyer-pair:<mac>' QR payload — the prefix is stripped). */
  mac: Scalars['String']['input'];
  /** Optional nickname to set on the device. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerPartnerAdminTeacherFilter = {
  q?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ViewerPartnerClassAssignTeachersInput = {
  classID: Scalars['ID']['input'];
  teacherProfileIDs: Array<Scalars['ID']['input']>;
};

export type ViewerPartnerClassRemoveTeachersInput = {
  classID: Scalars['ID']['input'];
  teacherProfileIDs: Array<Scalars['ID']['input']>;
};

export type ViewerPartnerCreateAssignTestInput = {
  checkPointId: Scalars['ID']['input'];
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  testLevelId: Scalars['ID']['input'];
  typeExam?: InputMaybe<TypeExamAssignTest>;
  typeInit?: InputMaybe<TypeInitAssignTest>;
};

export type ViewerPartnerCreateClassInput = {
  classLevelId: Scalars['ID']['input'];
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  onboardStep?: InputMaybe<Scalars['Int']['input']>;
  pin: Scalars['Boolean']['input'];
  targetNotification?: InputMaybe<Scalars['Boolean']['input']>;
  type: ClassType;
  weeklyTimeTarget?: InputMaybe<Scalars['Duration']['input']>;
};

export type ViewerPartnerSchoolInviteAppliedTeacherAcceptInput = {
  id: Scalars['ID']['input'];
};

export type ViewerPartnerSchoolInviteAppliedTeacherDeclineInput = {
  id: Scalars['ID']['input'];
};

export type ViewerPartnerSchoolInviteTeacherAcceptInput = {
  code: Scalars['String']['input'];
};

export type ViewerPartnerSchoolInviteTeacherDeclineInput = {
  code: Scalars['String']['input'];
};

export type ViewerPartnerSchoolInviteTeacherInput = {
  identifier?: InputMaybe<Array<Scalars['String']['input']>>;
  roleId: Scalars['ID']['input'];
};

export type ViewerPartnerSchoolInvitedTeacherDeleteInput = {
  id: Scalars['ID']['input'];
};

export type ViewerPartnerSchoolInvitedTeacherEditInput = {
  id: Scalars['ID']['input'];
  roleId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerPartnerSeenNotificationInput = {
  all?: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerPartnerTeacherFilter = {
  canAssignToClassId?: InputMaybe<Array<Scalars['ID']['input']>>;
  classIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ViewerPartnerTypeSubscription {
  DeleteSchool = 'DELETE_SCHOOL',
  DocumentUpdate = 'DOCUMENT_UPDATE',
  SchoolUpdate = 'SCHOOL_UPDATE'
}

export type ViewerRecoverPasswordInput = {
  withFirebaseEmail?: InputMaybe<ViewerRecoverPasswordWithFirebaseEmailInput>;
  withFirebasePhoneNumber?: InputMaybe<ViewerRecoverPasswordWithFirebasePhoneNumberInput>;
  withPhoneNumber?: InputMaybe<ViewerRecoverPasswordWithPhoneNumberInput>;
};

export type ViewerRecoverPasswordWithFirebaseEmailInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ViewerRecoverPasswordWithFirebasePhoneNumberInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ViewerRecoverPasswordWithPhoneNumberInput = {
  newPassword: Scalars['String']['input'];
  otpCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type ViewerRestoreInAppPurchasesInput = {
  appType?: AppTypeMobile;
};

export type ViewerSchoolInviteAcceptInput = {
  learnerProfileId: Scalars['ID']['input'];
  schoolId: Scalars['ID']['input'];
};

export type ViewerSeenAchievementInput = {
  name: AchievementName;
  tier: Scalars['Int']['input'];
};

export type ViewerSendOtpInput = {
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  otpFlow: AuthOtpFlow;
  phoneNumber: Scalars['String']['input'];
};

export enum ViewerSessionEventType {
  LearnerProfileUpdated = 'LEARNER_PROFILE_UPDATED',
  NewSession = 'NEW_SESSION',
  RestoredDiamondInAppPurchases = 'RESTORED_DIAMOND_IN_APP_PURCHASES',
  RestoredInAppPurchases = 'RESTORED_IN_APP_PURCHASES'
}

export type ViewerSignUpInput = {
  withFirebasePhoneNumber?: InputMaybe<ViewerSignUpWithFirebasePhoneNumberInput>;
  withPhoneNumber?: InputMaybe<ViewerSignUpWithPhoneNumberInput>;
};

export type ViewerSignUpWithFirebasePhoneNumberInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  refUserId?: InputMaybe<Scalars['ID']['input']>;
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type ViewerSignUpWithPhoneNumberInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  otpCode: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  refUserId?: InputMaybe<Scalars['ID']['input']>;
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerSwitchLearnerProfileInput = {
  learnerProfileId: Scalars['ID']['input'];
};

export type ViewerSwitchSchoolInput = {
  schoolId: Scalars['ID']['input'];
};

export type ViewerTeacherInvitationAcceptInput = {
  invitationId: Scalars['ID']['input'];
};

export type ViewerTranscriptionInput = {
  url: Scalars['String']['input'];
};

export type ViewerUnpairDeviceInput = {
  /** Global ID of the device to remove (must be owned by the current user). */
  deviceId: Scalars['ID']['input'];
};

export type ViewerUpdateDeviceInput = {
  /** Remote lock/unlock the device. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deviceId: Scalars['ID']['input'];
  /** Reassign to one of the current user's learner profiles. */
  learnerProfileId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerUpdateEmailInput = {
  email: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerUpdateFcmTokenInput = {
  appType?: AppTypeMobile;
  lang: Scalars['String']['input'];
  token: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type ViewerUpdateLearnerProfileInput = {
  additionalInfo?: InputMaybe<AdditionalInfoInput>;
  avatarId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  frameID?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['ID']['input'];
  ieltsCurrentScore?: InputMaybe<Scalars['Float']['input']>;
  ieltsExamDate?: InputMaybe<Scalars['DateTime']['input']>;
  ieltsTargetScore?: InputMaybe<Scalars['Float']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onboardingInfo?: InputMaybe<Array<MetaInfoInput>>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerUpdateParentProfileInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  avatarId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['ID']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerUpdatePasswordInput = {
  newPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ViewerUpdatePendingContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerUpdatePhoneNumberInput = {
  otpCode?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerUpdateTeacherProfileInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  avatarId?: InputMaybe<Scalars['String']['input']>;
  bankAccountInfo?: InputMaybe<BankAccountInfoInput>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['ID']['input'];
  isCurriculumManager?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onboardingInfo?: InputMaybe<Array<MetaInfoInput>>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
};

export type ViewerUpdateUsernameInput = {
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerVerifyOwnerByEmailTokenInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
  tokenType: TokenType;
};

export enum VnpayPaymentPackageActive {
  DiamondBasic = 'DIAMOND_BASIC',
  DiamondTrial = 'DIAMOND_TRIAL',
  DiamondWell = 'DIAMOND_WELL',
  FlyerIeltsOneYear = 'FLYER_IELTS_ONE_YEAR',
  FlyerIeltsSixMonths = 'FLYER_IELTS_SIX_MONTHS',
  FlyerIeltsThreeMonths = 'FLYER_IELTS_THREE_MONTHS',
  FlyerKidsFourYears = 'FLYER_KIDS_FOUR_YEARS',
  FlyerKidsOneYear = 'FLYER_KIDS_ONE_YEAR',
  FlyerKidsTwoYears = 'FLYER_KIDS_TWO_YEARS',
  FlyerMaxFourYears = 'FLYER_MAX_FOUR_YEARS',
  FlyerMaxOneYear = 'FLYER_MAX_ONE_YEAR',
  FlyerMaxTwoYears = 'FLYER_MAX_TWO_YEARS',
  FlyerTeensFourYears = 'FLYER_TEENS_FOUR_YEARS',
  FlyerTeensOneYear = 'FLYER_TEENS_ONE_YEAR',
  FlyerTeensTwoYears = 'FLYER_TEENS_TWO_YEARS',
  OneDay = 'ONE_DAY',
  PartnerDepositWallet = 'PARTNER_DEPOSIT_WALLET',
  PartnerSpeakingAi = 'PARTNER_SPEAKING_AI',
  TeadoTool = 'TEADO_TOOL',
  TeadoToolPlus = 'TEADO_TOOL_PLUS'
}

export enum VnpayPaymentSource {
  Exam = 'EXAM',
  Ielts = 'IELTS',
  Mobile = 'MOBILE',
  Partner = 'PARTNER',
  Web = 'WEB'
}

export enum VnpayPaymentStatus {
  Cancel = 'CANCEL',
  Create = 'CREATE',
  Error = 'ERROR',
  NotFound = 'NOT_FOUND',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum VnpayPaymentVnpLocale {
  En = 'en',
  Vn = 'vn'
}

export type VocabWordFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  isNullLevel?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Array<CefrLevel>>;
  text?: InputMaybe<Array<Scalars['String']['input']>>;
  textQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VocabWordOrder = {
  key?: InputMaybe<VocabWordOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum VocabWordOrderKey {
  Word = 'WORD'
}

export enum WalletCurrency {
  Usd = 'USD',
  Vnd = 'VND'
}

export enum WalletTransactionStatus {
  Cancel = 'CANCEL',
  Create = 'CREATE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum WalletTransactionTransactionType {
  Deposit = 'DEPOSIT',
  Payment = 'PAYMENT',
  Refund = 'REFUND',
  TransferIn = 'TRANSFER_IN',
  TransferOut = 'TRANSFER_OUT'
}

export type WeeklyStudentAssignTestWeakOrder = {
  key?: InputMaybe<WeeklyStudentAssignTestWeakOrderKey>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WeeklyStudentAssignTestWeakOrderKey {
  AccuracyLastWeek = 'ACCURACY_LAST_WEEK',
  NotCompletedLastWeek = 'NOT_COMPLETED_LAST_WEEK'
}

export enum WordDecision {
  Correct = 'correct',
  Incorrect = 'incorrect',
  Warning = 'warning'
}

export type WritingAiPromptInput = {
  system: Scalars['String']['input'];
};

export enum WritingCriteria {
  Communicative = 'Communicative',
  Content = 'Content',
  IeltsCoherenceAndCohesion = 'IeltsCoherenceAndCohesion',
  IeltsGrammaticalRangeAndAccuracy = 'IeltsGrammaticalRangeAndAccuracy',
  IeltsLexicalResource = 'IeltsLexicalResource',
  IeltsTaskPerformance = 'IeltsTaskPerformance',
  Language = 'Language',
  Organisation = 'Organisation'
}

export type WritingEndAttemptInput = {
  attemptId: Scalars['ID']['input'];
};

export type WritingImageInput = {
  imageId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type WritingMarkingCriteriaInput = {
  band: Scalars['Float']['input'];
  commentary?: InputMaybe<Scalars['String']['input']>;
  criteria: WritingCriteria;
};

export type WritingPartBodyInput = {
  questionChoices: Array<WritingQuestionInput>;
};

export type WritingPartFilter = {
  nameQ?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WritingQuestionInput = {
  aiPrompt?: InputMaybe<WritingAiPromptInput>;
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  highlightText?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<WritingImageInput>>;
  position: Scalars['Int']['input'];
  sampleAnswerHtml?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleContentHtml?: InputMaybe<Scalars['String']['input']>;
};

export type WritingStartAttemptInput = {
  assignTestId?: InputMaybe<Scalars['ID']['input']>;
  bookLessonId?: InputMaybe<Scalars['ID']['input']>;
  checkPointId: Scalars['ID']['input'];
  requestAIReview?: InputMaybe<Scalars['Boolean']['input']>;
  requestReview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WritingSubmitPartAttemptInput = {
  answer: Scalars['String']['input'];
  attemptId: Scalars['ID']['input'];
  partId: Scalars['ID']['input'];
  questionChoiceId?: InputMaybe<Scalars['String']['input']>;
};

export type WritingUpdateInput = {
  markingCriteria?: InputMaybe<Array<WritingMarkingCriteriaInput>>;
  partID: Scalars['ID']['input'];
  teacherCommentsAnswers?: InputMaybe<Array<TeacherCommentDetailInput>>;
  teacherFixedAnswer?: InputMaybe<Scalars['JSON']['input']>;
  teacherWordCount?: InputMaybe<Scalars['Int']['input']>;
};

export type TestLevelBySlugQueryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type TestLevelBySlugQueryQuery = { testLevelBySlug?: { slug: string, name: string, playlistId?: string | null, typeTestLevel?: TypeExamTestLevel | null, description?: string | null, descriptionEn?: string | null, id: string } | null };

export type TestLevelQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TestLevelQueryQuery = { testLevel?: { slug: string, name: string, playlistId?: string | null, description?: string | null, descriptionEn?: string | null, id: string } | null };

export type TestLevelFragment = { slug: string, name: string, playlistId?: string | null, typeTestLevel?: TypeExamTestLevel | null, description?: string | null, descriptionEn?: string | null, id: string };

export type UserErrorFragment = { message: string, code: UserErrorCode, field?: Array<string> | null, param: { value?: string | null } };

export type LearnerAchievementFragment = { id: string, learnerAchievementId: string, name: AchievementName, tier: number, level: number, maxLevel: number, value: number, nextLevelValue: number, seen: boolean, dateReceived?: string | null };

export type TestLevelsWithFilterQueryVariables = Exact<{
  filterBy?: InputMaybe<TestLevelFilter>;
}>;


export type TestLevelsWithFilterQuery = { testLevels: { nodes: Array<{ slug: string, name: string, playlistId?: string | null, typeTestLevel?: TypeExamTestLevel | null, description?: string | null, descriptionEn?: string | null, id: string }> } };

export type LearnerProfileRankingFragment = { id: string, learnerProfileId: string, displayName: string, avatarUrl?: string | null, gender?: Gender | null, dateOfBirth?: string | null, school?: { id: string, schoolId: string, name: string, province?: { id: string, provinceId: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null };

export type GetTestLevelRankingQueryVariables = Exact<{
  frequency: RankFrequency;
  testLevelId: Scalars['ID']['input'];
  classCode?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<LearnerTestLevelRankFilter>;
  filterBy2?: InputMaybe<LearnerTestLevelRankFilter>;
  includeProfileRank: Scalars['Boolean']['input'];
}>;


export type GetTestLevelRankingQuery = { learnerTestLevelRanks: { totalCount?: number | null, edges: Array<{ cursor: string, node: { rank: number, score: number, grade: number, learnerProfile: { id: string, learnerProfileId: string, displayName: string, avatarUrl?: string | null, gender?: Gender | null, dateOfBirth?: string | null, school?: { id: string, schoolId: string, name: string, province?: { id: string, provinceId: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null } } }>, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null } }, profileLearnerTestLevelRanks?: { edges: Array<{ cursor: string, node: { rank: number, score: number, grade: number, learnerProfile: { id: string, learnerProfileId: string, displayName: string, avatarUrl?: string | null, gender?: Gender | null, dateOfBirth?: string | null, school?: { id: string, schoolId: string, name: string, province?: { id: string, provinceId: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null } } }> } };

export type LearnerChallengeRanksQueryVariables = Exact<{
  challengeCode: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<LearnerChallengeRankFilter>;
  filterBy2?: InputMaybe<LearnerChallengeRankFilter>;
  includeProfileRank: Scalars['Boolean']['input'];
}>;


export type LearnerChallengeRanksQuery = { learnerChallengeRanks: { totalCount?: number | null, edges: Array<{ cursor: string, node: { id: string, learnerChallengeRankId: string, grade?: number | null, rank: number, score?: number | null, learnerProfile: { id: string, learnerProfileId: string, displayName: string, avatarUrl?: string | null, gender?: Gender | null, dateOfBirth?: string | null, school?: { id: string, schoolId: string, name: string, province?: { id: string, provinceId: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null } } }>, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null } }, profileLearnerChallengeRank?: { totalCount?: number | null, edges: Array<{ cursor: string, node: { id: string, learnerChallengeRankId: string, grade?: number | null, rank: number, score?: number | null, learnerProfile: { id: string, learnerProfileId: string, displayName: string, avatarUrl?: string | null, gender?: Gender | null, dateOfBirth?: string | null, school?: { id: string, schoolId: string, name: string, province?: { id: string, provinceId: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null } } }> } };

export type SchoolTestLevelRanksQueryVariables = Exact<{
  frequency: RankFrequency;
  testLevelId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<SchoolTestLevelRankFilter>;
}>;


export type SchoolTestLevelRanksQuery = { schoolTestLevelRanks: { pageInfo: { hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ cursor: string, node: { id: string, schoolTestLevelRankId: string, totalGrade: number, totalScore: number, avgAccuracy: number, rank: number, school: { id: string, name: string, schoolId: string, province?: { id: string, name: string, provinceId: string } | null } } }> } };

export type LearnerProfileByIdQueryVariables = Exact<{
  learnerProfileId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<UserAttemptFilter>;
}>;


export type LearnerProfileByIdQuery = { learnerProfile?: { id: string, learnerProfileId: string, displayName: string, avatarUrl?: string | null, coin: number, star: number, wisdomStoneBalance?: number | null, frameImage?: { id: string, url: string } | null, achievements: Array<{ id: string, learnerAchievementId: string, name: AchievementName, tier: number, level: number, maxLevel: number, value: number, nextLevelValue: number, seen: boolean, dateReceived?: string | null }>, attemptStats?: { totalGrade: number, accuracy: number, studyTime: string, completedTest: number } | null, userAttempts: { edges: Array<{ node: { id: string, submittedAt?: string | null, executionTime?: string | null, grade?: number | null, maxGrade?: number | null, testLevel?: { id: string, name: string } | null, checkPoint?: { id: string, name: string, nameEn?: string | null } | null } }>, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null } }, classStudent?: { id: string, class?: { id: string, classId: string } | null } | null } | null };

export type GetTestLevelRankingDetailQueryVariables = Exact<{
  frequency: RankFrequency;
  testLevelId: Scalars['ID']['input'];
  classCode?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<LearnerTestLevelRankFilter>;
}>;


export type GetTestLevelRankingDetailQuery = { learnerTestLevelRanksDetail: { totalCount?: number | null, nodes: Array<{ rank: number, score: number, grade: number, learnerProfile: { id: string, learnerProfileId: string, displayName: string, avatarUrl?: string | null, gender?: Gender | null, dateOfBirth?: string | null, school?: { id: string, schoolId: string, name: string, province?: { id: string, provinceId: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null } }>, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null } } };

export type ProvincesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProvincesQuery = { provinces: Array<{ id: string, name: string, provinceId: string }> };

export type SchoolsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<SchoolFilter>;
  filterBy2?: InputMaybe<SchoolFilter>;
}>;


export type SchoolsQuery = { schools: { edges: Array<{ node: { id: string, name: string, schoolId: string, domain?: { id: string } | null, province?: { id: string, name: string, provinceId: string } | null } }>, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null, startCursor?: string | null, hasPreviousPage?: boolean | null } }, schoolsInit: { edges: Array<{ node: { id: string, name: string, schoolId: string, domain?: { id: string } | null, province?: { id: string, name: string, provinceId: string } | null } }> } };

export type PartnerDomainQueryQueryVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type PartnerDomainQueryQuery = { partnerDomain?: { id: string } | null };

export type AuthProviderCreateAnonymousLearnerProfileMutationMutationVariables = Exact<{
  input: ViewerCreateLearnerProfileInput;
}>;


export type AuthProviderCreateAnonymousLearnerProfileMutationMutation = { viewerCreateLearnerProfile: { learnerProfile?: { id: string, learnerProfileId: string } | null, userErrors: Array<{ message: string, code: UserErrorCode, field?: Array<string> | null, param: { value?: string | null } }> } };

export type AuthProviderUpdateAnonymousLearnerProfileMutationMutationVariables = Exact<{
  input: ViewerUpdateLearnerProfileInput;
}>;


export type AuthProviderUpdateAnonymousLearnerProfileMutationMutation = { viewerUpdateLearnerProfile: { learnerProfile?: { id: string, learnerProfileId: string } | null, userErrors: Array<{ message: string, code: UserErrorCode, field?: Array<string> | null, param: { value?: string | null } }> } };

export type LearnerProfileFragment = { id: string, learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, coin: number, star: number, placementLevel?: CefrLevel | null, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null };

export type ViewerFragment = { id: string, userId: string, email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, adminRole?: UserAdminRole | null, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { id: string, learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, coin: number, star: number, placementLevel?: CefrLevel | null, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ id: string, learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } };

export type AuthProviderViewerSessionQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthProviderViewerSessionQueryQuery = { viewerSession: { viewer?: { id: string, userId: string, email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, adminRole?: UserAdminRole | null, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { id: string, learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, coin: number, star: number, placementLevel?: CefrLevel | null, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ id: string, learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, loginSession?: { id: string, userSessionId: string, active: boolean, createdAt: string, userAgent: { summary: string }, deactivatedBySession?: { id: string, userSessionId: string, active: boolean, createdAt: string, userAgent: { summary: string } } | null } | null } };

export type AuthProviderViewerLogOutMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type AuthProviderViewerLogOutMutationMutation = { viewerLogOut: { userErrors: Array<{ code: UserErrorCode }> } };

export type AuthProviderViewerSwitchLearnerProfileMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AuthProviderViewerSwitchLearnerProfileMutationMutation = { viewerSwitchLearnerProfile: { viewer?: { id: string, userId: string, email?: string | null, phoneNumber?: string | null, emailVerified: boolean, username?: string | null, hasPassword: boolean, subscriptionExpiresAt?: string | null, isSubscribing: boolean, canCreateLearnerProfile: boolean, diamond: number, teacherVerified: boolean, adminRole?: UserAdminRole | null, subscriptions: { nodes: Array<{ package: { name: FlyerPackageName } }> }, currentLearnerProfile?: { id: string, learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, gender?: Gender | null, avatarUrl?: string | null, isAnonymous: boolean, canClaimDailyReward: boolean, canRequestTeacher: boolean, coin: number, star: number, placementLevel?: CefrLevel | null, frameImage?: { id: string, url: string } | null, classStudent?: { id: string, class?: { id: string, classId: string, code: string, name: string } | null } | null, domains?: Array<{ id: string, customDomainId: string, domainName?: string | null, showDiamond: boolean }> | null, streakData?: { currentStreak?: { count: number, endDate: string, startDate: string } | null } | null, school?: { name: string, id: string, province?: { name: string, id: string } | null } | null } | null, learnerProfiles: { nodes: Array<{ id: string, learnerProfileId: string, firstName: string, lastName?: string | null, displayName: string, dateOfBirth?: string | null, avatarUrl?: string | null, isAnonymous: boolean, classStudent?: { class?: { id: string, classId: string, code: string, name: string } | null } | null, frameImage?: { id: string, url: string } | null }> } } | null, userErrors: Array<{ code: UserErrorCode }> } };

export type AuthProviderViewerSessionEventSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AuthProviderViewerSessionEventSubscription = { viewerSessionEvent: { event: ViewerSessionEventType } };

export const TestLevelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestLevel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistId"}},{"kind":"Field","name":{"kind":"Name","value":"typeTestLevel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}}]}}]} as unknown as DocumentNode<TestLevelFragment, unknown>;
export const UserErrorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UserErrorFragment, unknown>;
export const LearnerAchievementFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerAchievement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerAchievement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerAchievementId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"maxLevel"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"nextLevelValue"}},{"kind":"Field","name":{"kind":"Name","value":"seen"}},{"kind":"Field","name":{"kind":"Name","value":"dateReceived"}}]}}]} as unknown as DocumentNode<LearnerAchievementFragment, unknown>;
export const LearnerProfileRankingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"learnerProfileRanking"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}}]} as unknown as DocumentNode<LearnerProfileRankingFragment, unknown>;
export const LearnerProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<LearnerProfileFragment, unknown>;
export const ViewerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerFragment, unknown>;
export const TestLevelBySlugQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TestLevelBySlugQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testLevelBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestLevel"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestLevel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistId"}},{"kind":"Field","name":{"kind":"Name","value":"typeTestLevel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}}]}}]} as unknown as DocumentNode<TestLevelBySlugQueryQuery, TestLevelBySlugQueryQueryVariables>;
export const TestLevelQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TestLevelQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}}]}}]}}]} as unknown as DocumentNode<TestLevelQueryQuery, TestLevelQueryQueryVariables>;
export const TestLevelsWithFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TestLevelsWithFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevelFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testLevels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestLevel"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestLevel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TestLevel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"testLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistId"}},{"kind":"Field","name":{"kind":"Name","value":"typeTestLevel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}}]}}]} as unknown as DocumentNode<TestLevelsWithFilterQuery, TestLevelsWithFilterQueryVariables>;
export const GetTestLevelRankingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTestLevelRanking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frequency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RankFrequency"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"testLevelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"classCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerTestLevelRankFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerTestLevelRankFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeProfileRank"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerTestLevelRanks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"frequency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frequency"}}},{"kind":"Argument","name":{"kind":"Name","value":"testLevelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"testLevelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"classCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"classCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"learnerProfileRanking"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grade"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"profileLearnerTestLevelRanks"},"name":{"kind":"Name","value":"learnerTestLevelRanks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"frequency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frequency"}}},{"kind":"Argument","name":{"kind":"Name","value":"testLevelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"testLevelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"classCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"classCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy2"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeProfileRank"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"learnerProfileRanking"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grade"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"learnerProfileRanking"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}}]} as unknown as DocumentNode<GetTestLevelRankingQuery, GetTestLevelRankingQueryVariables>;
export const LearnerChallengeRanksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LearnerChallengeRanks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"challengeCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerChallengeRankFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerChallengeRankFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeProfileRank"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerChallengeRanks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"challengeCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"challengeCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerChallengeRankId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"learnerProfileRanking"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"profileLearnerChallengeRank"},"name":{"kind":"Name","value":"learnerChallengeRanks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"challengeCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"challengeCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy2"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeProfileRank"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerChallengeRankId"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"learnerProfileRanking"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"learnerProfileRanking"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}}]} as unknown as DocumentNode<LearnerChallengeRanksQuery, LearnerChallengeRanksQueryVariables>;
export const SchoolTestLevelRanksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SchoolTestLevelRanks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frequency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RankFrequency"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"testLevelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SchoolTestLevelRankFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schoolTestLevelRanks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"frequency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frequency"}}},{"kind":"Argument","name":{"kind":"Name","value":"testLevelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"testLevelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolTestLevelRankId"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provinceId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"avgAccuracy"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]}}]} as unknown as DocumentNode<SchoolTestLevelRanksQuery, SchoolTestLevelRanksQueryVariables>;
export const LearnerProfileByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LearnerProfileById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"learnerProfileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserAttemptFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"learnerProfileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerAchievement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attemptStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"accuracy"}},{"kind":"Field","name":{"kind":"Name","value":"studyTime"}},{"kind":"Field","name":{"kind":"Name","value":"completedTest"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userAttempts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"testLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkPoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"executionTime"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"wisdomStoneBalance"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerAchievement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerAchievement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerAchievementId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"maxLevel"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"nextLevelValue"}},{"kind":"Field","name":{"kind":"Name","value":"seen"}},{"kind":"Field","name":{"kind":"Name","value":"dateReceived"}}]}}]} as unknown as DocumentNode<LearnerProfileByIdQuery, LearnerProfileByIdQueryVariables>;
export const GetTestLevelRankingDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTestLevelRankingDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frequency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RankFrequency"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"testLevelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"classCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerTestLevelRankFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"learnerTestLevelRanksDetail"},"name":{"kind":"Name","value":"learnerTestLevelRanks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"frequency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frequency"}}},{"kind":"Argument","name":{"kind":"Name","value":"testLevelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"testLevelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"classCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"classCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"learnerProfileRanking"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grade"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"learnerProfileRanking"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}}]} as unknown as DocumentNode<GetTestLevelRankingDetailQuery, GetTestLevelRankingDetailQueryVariables>;
export const ProvincesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Provinces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provinces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provinceId"}}]}}]}}]} as unknown as DocumentNode<ProvincesQuery, ProvincesQueryVariables>;
export const SchoolsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Schools"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SchoolFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SchoolFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provinceId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"schoolsInit"},"name":{"kind":"Name","value":"schools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provinceId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"schoolId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SchoolsQuery, SchoolsQueryVariables>;
export const PartnerDomainQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDomainQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerDomain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PartnerDomainQueryQuery, PartnerDomainQueryQueryVariables>;
export const AuthProviderCreateAnonymousLearnerProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthProviderCreateAnonymousLearnerProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerCreateLearnerProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerCreateLearnerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthProviderCreateAnonymousLearnerProfileMutationMutation, AuthProviderCreateAnonymousLearnerProfileMutationMutationVariables>;
export const AuthProviderUpdateAnonymousLearnerProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthProviderUpdateAnonymousLearnerProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerUpdateLearnerProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUpdateLearnerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"param"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthProviderUpdateAnonymousLearnerProfileMutationMutation, AuthProviderUpdateAnonymousLearnerProfileMutationMutationVariables>;
export const AuthProviderViewerSessionQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthProviderViewerSessionQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loginSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedBySession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<AuthProviderViewerSessionQueryQuery, AuthProviderViewerSessionQueryQueryVariables>;
export const AuthProviderViewerLogOutMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthProviderViewerLogOutMutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerLogOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<AuthProviderViewerLogOutMutationMutation, AuthProviderViewerLogOutMutationMutationVariables>;
export const AuthProviderViewerSwitchLearnerProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthProviderViewerSwitchLearnerProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerSwitchLearnerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"learnerProfileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Viewer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LearnerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"canClaimDailyReward"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestTeacher"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customDomainId"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"showDiamond"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coin"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"star"}},{"kind":"Field","name":{"kind":"Name","value":"placementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"schoolId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Viewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribing"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateLearnerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"diamond"}},{"kind":"Field","name":{"kind":"Name","value":"teacherVerified"}},{"kind":"Field","name":{"kind":"Name","value":"currentLearnerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LearnerProfile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"learnerProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"classStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"classId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminRole"}}]}}]} as unknown as DocumentNode<AuthProviderViewerSwitchLearnerProfileMutationMutation, AuthProviderViewerSwitchLearnerProfileMutationMutationVariables>;
export const AuthProviderViewerSessionEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AuthProviderViewerSessionEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerSessionEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}}]}}]}}]} as unknown as DocumentNode<AuthProviderViewerSessionEventSubscription, AuthProviderViewerSessionEventSubscriptionVariables>;